export const translations = {
  en: {
    "app.title": "Product Library",
    "app.caption": "Product Data Library",
    "products.recordsFound": "records found",
    "nav.products": "Products",
    "nav.quotes": "Quotations",
    "nav.customers": "Customers",
    "nav.factories": "Factories",
    "nav.procurementQuotes": "Procurement Quotes",
    "nav.productOverview": "All Product Photos",
    "po.title": "All Product Photos",
    "po.records": "records",
    "po.loading": "Loading…",
    "po.empty": "No records match your filters",
    "po.searchHint": "Search item no / description / buyer",
    "po.all": "All",
    "po.category": "Category",
    "po.buyer": "Buyer",
    "po.photo_type": "Photo type",
    "po.clear": "Clear",
    "po.prev": "Prev",
    "po.next": "Next",
    "po.syncTitle": "Product Overview Sync (FileMaker)",
    "po.syncHint": "Pulls the FileMaker 「产品一览表 · product_photo」 layout into the local catalogue; photos are re-hosted on R2 so browsers render without FM credentials.",
    "po.sync": "Start Sync",
    "po.syncing": "Syncing",
    "po.syncStarted": "Sync started",
    "po.createdAt": "Created",
    "po.dateRange": "Date",
    "sample.pickProducts": "Select products",
    "sample.pickSearchPlaceholder": "Search item no. / description / buyer…",
    "sample.pickedCount": "{n} selected",
    "sample.addSelected": "Add to list",
    "sample.addedToast": "Added {n} product(s), skipped {s} duplicate(s)",
    "sample.uploadPhoto": "Upload photos",
    "sample.uploadedToast": "Uploaded {n} photo(s)",
    "po.dateRangeHint": "Available data range: {from} ~ {to}",
    "po.autoSyncDaily": "Auto-sync daily at {time} (US Eastern) — text only, photos backfilled",
    "po.autoSyncLast": "last auto-sync {at}, {n} records updated",
    "po.autoSyncNever": "auto-sync has not run yet",
    "po.autoAiProgress": "Processing {kind} {done}/{total}",
    "po.autoAiLast": "Last run {time} · +{d} descriptions · +{c} cutouts{skip}",
    "po.autoAiTitle": "Idle background AI",
    "po.autoAiCutout": "Cutout",
    "po.autoAiHint": "Processes a small batch every 10 minutes; skipped while a sync runs or disk is low.",
    "po.autoAiDesc": "Auto description",
    "po.autoAiRunNow": "Run one batch now",
    "po.autoAiStarted": "Batch started — status refreshes shortly",
    "po.autoAiBusy": "A batch is already running",
    "po.autoAiPending": "Pending: {d} without description · {c} App uploads to cut out · {b} per batch",
    "po.syncFailed": "Sync failed",
    "po.syncStop": "Stop Sync",
    "po.syncStopping": "Stopping…",
    "po.syncStopRequested": "Stop requested — waiting for current batch to finish…",
    "po.syncStopFailed": "Stop failed",
    "po.syncStopped": "Stopped",
    "po.syncDone": "Sync complete: {n} records updated, {p} photos downloaded",
    "po.syncIdle": "Never synced",
    "po.photos": "photos",
    "po.loadFailed": "Failed to load records",
    "po.import.button": "Import Photos",
    "po.import.title": "Import product photos",
    "po.import.hint": "The filename becomes the item number; you can edit each one below.",
    "po.import.aiDescribe": "Auto-generate descriptions with AI (slightly slower import)",
    "po.import.takePhoto": "Take photo",
    "po.import.fromGallery": "Choose from gallery",
    "po.import.dropHint": "Drop images here or click to choose",
    "po.import.maxHint": "up to 100 files",
    "po.import.filesUnit": "files",
    "po.import.clearAll": "Clear all",
    "po.import.submit": "Import",
    "po.import.uploading": "Importing…",
    "po.import.pickFirst": "Please choose images first",
    "po.import.done": "Import complete",
    "po.import.failed": "Import failed",
    "po.import.partialFail": "file(s) failed",
    "po.import.tooMany": "Max",
    "po.import.unsupportedSkipped": "unsupported file(s) skipped",
    "po.detail.itemNumber": "Item No.",
    "po.detail.photoType": "Photo Type",
    "po.detail.description": "Description",
    "po.detail.noDescription": "No description",
    "po.detail.removeBg": "AI Remove Background",
    "po.detail.processing": "AI processing…",
    "po.detail.bgRemoved": "Background removed",
    "po.detail.bgFailed": "AI background removal failed",
    "po.detail.bgRemovedTag": "BG removed",
    "po.detail.restore": "Restore Original",
    "po.detail.restored": "Original restored",
    "po.detail.restoring": "Restoring…",
    "po.detail.genDesc": "AI Generate",
    "po.detail.descLoading": "AI generating description…",
    "po.detail.descGenerated": "Description generated",
    "po.detail.edit": "Edit",
    "po.detail.save": "Save",
    "po.detail.saved": "Saved",
    "po.detail.saving": "Saving…",
    "po.detail.actionFailed": "Action failed",
    "common.cancel": "Cancel",
    "po.detail.webappOrigin": "WebApp Upload",
    "po.date": "Date",
    "common.close": "Close",
    "nav.tags": "Tag Management",
    "nav.marketSurvey": "Market Survey",
    "market.title": "Market Product Survey",
    "market.newSurvey": "New Survey",
    "market.emptyList": "No surveys yet — click 新建 to create one",
    "market.selectingFor": "Selecting products for:",
    "market.backToList": "Back to survey list",
    "market.surveyList": "Survey List",
    "market.productList": "Product List",
    "market.fmSync": "Sync FileMaker",
    "market.fmSyncing": "Syncing",
    "market.stop": "Stop",
    "market.stopSent": "Stop signal sent",
    "market.myFavorites": "My favourites",
    "api.panelTitle": "External app API (read-only)",
    "api.panelHint": "Connection parameters for an external app. Create a readonly token below and use these values in your app.",
    "api.copied": "Copied",
    "api.endpointList": "Available endpoints",
    "api.noteReadonly": "Readonly tokens allow GET only; any write returns 403.",
    "api.noteRole": "A token inherits the creator's role — create it as admin to read everything.",
    "api.noteSecret": "Keep the token on your server (env var); never ship it in front-end code.",
    "market.favAll": "All favourites",
    "market.favUngrouped": "Ungrouped",
    "market.favNewGroup": "New group",
    "market.favGroups": "Favourite groups",
    "market.favNoGroups": "No groups yet — create one in the favourites bar.",
    "market.filterStore": "Store",
    "market.filterStoreAll": "All Stores",
    "market.filterDateFrom": "Start Date",
    "market.filterDateTo": "End Date",
    "market.filterCategory": "Category",
    "market.filterCategoryAll": "All Categories",
    "market.filterProject": "Project",
    "market.filterProjectAll": "All Projects",
    "market.filterPurpose": "Photo Type",
    "market.filterPurposeAll": "All Types",
    "market.searchName": "Search product name",
    "market.reset": "Reset",
    "market.selected": "Selected",
    "market.clearSelection": "Clear selection",
    "market.selectAll": "Select all ({n})",
    "market.unselectAll": "Unselect all",
    "market.shareLink": "Create link",
    "market.shareSetupTitle": "Create a public link",
    "market.shareSetupHint": "{n} selected products will be shown on a public photo wall (valid 30 days, no login needed).",
    "market.shareTitleLabel": "Link title (optional)",
    "market.shareTitlePlaceholder": "e.g. Walmart autumn survey",
    "market.shareCreate": "Create link",
    "market.shareDialogTitle": "Public link created",
    "market.shareDialogHint": "{n} products · anyone with this link can browse the photo wall without logging in. Valid until {date}.",
    "market.shareCopy": "Copy",
    "market.shareCopied": "Link copied",
    "market.shareOpen": "Open link",
    "market.selectionTtl": "kept for 24h",
    "market.batchPdf": "Thumbnail PDF",
    "market.batchImport": "Import to Library",
    "market.batchPdfGenerating": "Generating…",
    "market.batchImportDone": "Import done · created {created} · skipped {skipped}",
    "market.loadMore": "Load more",
    "market.showing": "Showing {shown} of {total}",
    "market.emptyProducts": "No product records yet — create a survey and upload photos",
    "market.noImage": "No image",
    "market.photoCount": "photos",
    "market.productCount": "products",
    "market.emptySurveyProducts": "No products in this survey — click Import Photos",
    "market.importPhotos": "Import Photos",
    "market.editTitle": "Edit Product",
    "market.editProductId": "Product ID",
    "market.editDescription": "Description",
    "market.editCategory": "Category",
    "market.editCategoryPlaceholder": "Select category",
    "market.editCategoryNone": "— None —",
    "market.editProject": "Project",
    "market.editProjectPlaceholder": "Select project",
    "market.editProjectNewPlaceholder": "Enter project name",
    "market.editProjectNone": "— None —",
    "market.editProjectNew": "New project…",
    "market.editCountryOfOrigin": "Country of Origin",
    "market.editSupplier": "Supplier",
    "market.editNotes": "Notes",
    "market.editPhotoTotal": "Total photos for this product:",
    "market.zoom": "Zoom in",
    "market.saved": "Saved",
    "market.delete": "Delete",
    "market.deleteConfirm": "Delete this product record? This action cannot be undone.",
    "market.deleted": "Deleted",
    "market.cancel": "Cancel",
    "market.save": "Save",
    "market.uploadTitle": "Upload Market Survey Photos",
    "market.uploadClickToPick": "Click to choose files",
    "market.uploadHint": "JPG · PNG · HEIC · WebP · ≤ 300 files · auto compressed to 3MB",
    "market.uploadPicked": "Picked",
    "market.uploadSucceeded": "Success",
    "market.uploadFailed": "Failed",
    "market.uploadClear": "Clear",
    "market.uploadRetryFailed": "Retry failed",
    "market.uploadPreset": "Preset (applied to all uploads)",
    "market.uploadStore": "Store",
    "market.uploadDate": "Date",
    "market.uploadPurposeSelect": "Select purpose",
    "market.uploadProjectSelect": "Select project",
    "market.uploadCategorySelect": "Select category",
    "market.uploadPurposeCustom": "+ New purpose…",
    "market.uploadProjectCustom": "+ New project…",
    "market.uploadPurposeNew": "New purpose name",
    "market.uploadProjectNew": "New project name",
    "market.uploadClose": "Close",
    "market.uploadStart": "Start Upload",
    "market.uploadTooMany": "Max 300 per batch",
    "market.uploadPurposeRequired": "Please select the photo purpose",
    "market.uploadDone": "Upload complete",
    "market.newSurveyTitle": "New Survey",
    "market.newSurveyStore": "Store",
    "market.newSurveyStorePlaceholder": "Select or enter a store",
    "market.newSurveyDate": "Date",
    "market.newSurveySurveyor": "Surveyor",
    "market.newSurveyNotes": "Notes",
    "market.newSurveyCreate": "Create",
    "market.newSurveyCreated": "Survey created",
    "market.syncStarted": "FileMaker sync started; the page will refresh shortly",
    "market.syncDoneToast": "Sync complete · new {created} · existing {existing} · errors {errors}",
    "market.syncFailed": "Sync failed",
    "tags.title": "Tag Management",
    "tags.allTags": "All Tags",
    "tags.hideSidebar": "Hide sidebar",
    "tags.showSidebar": "Show sidebar",
    "tags.allProducts": "All Products",
    "tags.addNew": "Add Tag",
    "tags.newTagPlaceholder": "New tag name",
    "tags.onlyMineHint": "Only tags you created or that were shared with you (10 newest)",
    "tags.createdOk": "Tag created",
    "tags.createFailed": "Could not create the tag",
    "tags.share": "Share",
    "tags.shareTitle": "Share tag",
    "tags.shareHint": "Selected users can see and use this tag",
    "tags.shareSaved": "Sharing updated",
    "tags.shareFailed": "Could not update sharing",
    "tags.noUsers": "No users available",
    "tags.sharedToMe": "shared",
    "co.attachTitle": "Order product data",
    "co.importBtn": "Import order data",
    "co.dialogTitle": "Import order product data",
    "co.noPhoto": "No product photo",
    "co.dialogSubtitle": "Search the order product data and import its carton info",
    "co.searchLabel": "Search CN / EN name / item no. / contract no. / factory",
    "co.searchPlaceholder": "Type a keyword",
    "co.contractNo": "Contract no.",
    "co.customer": "Customer",
    "co.factory": "Factory",
    "co.contractDate": "Contract date",
    "co.all": "All",
    "co.search": "Search",
    "co.reset": "Reset",
    "co.refresh": "Refresh",
    "co.recordCount": "{n} records",
    "co.colName": "Product name",
    "co.colItem": "Item no.",
    "co.colContract": "Contract no.",
    "co.colPacking": "Carton info",
    "co.colPurchasePrice": "Purchase price",
    "co.gtPrice": "GT Price",
    "co.exportPrice": "Export price",
    "co.lowestLabel": "Lowest ever",
    "co.lowestOf": "lowest of {n} priced contracts",
    "co.lowestBadge": "LOW",
    "co.colQty": "Qty",
    "co.vsCurrent": "Current cost",
    "co.alsoImportPrice": "Also import purchase price into factory cost",
    "co.colActions": "Actions",
    "co.preview": "Preview",
    "co.import": "Import",
    "co.selectedTitle": "Selected carton data",
    "co.selectHint": "Pick a row to preview its carton data",
    "co.packingWillImport": "Carton info (will be imported)",
    "co.packingRate": "Packing rate",
    "co.length": "L",
    "co.width": "W",
    "co.height": "H",
    "co.grossWeight": "Gross wt.",
    "co.overwriteHint": "Confirming the import overwrites the current carton data.",
    "co.confirmImport": "Confirm import",
    "co.imported": "Carton data imported",
    "co.empty": "No matching order product data",
    "co.noMatch": "No contract records found for this item number",
    "co.matchedBy": "match",
    "co.perPage": "/ page",
    "co.syncTitle": "Contract order products sync",
    "co.syncHint": "One-way pull from the FileMaker contract order database. Runs daily at 07:00 America/New_York and can be triggered here.",
    "co.sinceLabel": "Start date (MM/DD/YYYY)",
    "co.syncing": "Syncing",
    "co.syncNow": "Sync now",
    "co.syncCount": "{n} order product records stored",

    "tags.myProducts": "My products",
    "tags.myProductsHint": "Show only products where 外销 or 采购 is me",
    "tags.myProductsFallback": "No products assigned to you — showing all products",
    "tags.searchTag": "Search tags",
    "tags.searchProduct": "Search products (SKU / item # / description)",
    "tags.label": "Tag",
    "tags.productsShown": "products",
    "tags.empty": "No products under this tag yet",
    "tags.newTitle": "New Tag",
    "tags.editTitle": "Edit Tag",
    "tags.name": "Name",
    "tags.color": "Color",
    "tags.saved": "Saved",
    "tags.deleted": "Deleted",
    "tags.deleteTitle": "Delete Tag",
    "tags.deleteConfirm": "Delete tag",
    "tags.deleteNote": "The tag will be hidden. Products already tagged keep their label.",
    "tags.rename": "Rename",
    "tags.changeColor": "Change color",
    "tags.delete": "Delete",
    "tags.emptyName": "Tag name is required",
    "tags.addTag": "Add tag",
    "tags.noMatch": "No matching tag",
    "tags.allSelected": "All tags selected",
    "tags.batchAddTag": "Add tag to selected",
    "tags.addToQuote": "Add to quote",
    "tags.batchRemoveTag": "Remove from this tag",
    "tags.batchAddTitle": "Add tag to selected products",
    "tags.batchAdded": "Tag added",
    "tags.batchRemoved": "Tag removed",
    "tags.selectedCount": "selected",
    "tags.emptyDict": "No tags created yet",
    "common.clear": "Clear",
    "nav.help": "Help",
    "pq.title": "Procurement Quotes",
    "pq.records": "records",
    "pq.searchPlaceholder": "Search item no. / name / factory / customer — press Enter",
    "pq.searchButton": "Search",
    "pq.resetColumns": "Reset widths",
    "pq.columns": "Columns",
    "pq.columnsShowAll": "Show all",
    "pq.resizeHint": "Drag to resize column",
    "pq.dateFrom": "From date",
    "pq.dateTo": "To date",
    "pq.allBuyers": "All sales",
    "pq.allCustomers": "All customers",
    "pq.delete": "Delete",
    "pq.deleteConfirm": "Delete this quote? This can't be undone.",
    "pq.deleted": "Deleted",
    "pq.deleteDisabledHint": "You can only delete your own quotes from today",
    "pq.presetToday": "Today",
    "pq.presetWeek": "This week",
    "pq.clearFilters": "Clear filters",
    "pq.priceMin": "Min price",
    "pq.priceMax": "Max price",
    "pq.newButton": "New Record",
    "pq.newTitle": "New Procurement Quote",
    "pq.optionalFields": "Optional fields",
    "pq.sourceHint": "Saved changes are queued durably and pushed to FileMaker immediately. Gross weight and tags stay in the APP.",
    "pq.savedApp": "Saved to APP",
    "pq.draftRetained": "Not saved — draft retained, please retry",
    "pq.syncDetails": "Sync status and history",
    "pq.retrySync": "Retry sync",
    "pq.retryQueued": "Sync retry queued",
    "pq.syncState.pending": "Saved to APP · Waiting for FileMaker",
    "pq.syncState.pushing": "Saved to APP · Syncing",
    "pq.syncState.retry": "Saved to APP · Retry pending",
    "pq.syncState.synced": "Synced to FileMaker",
    "pq.syncState.conflict": "Field conflict · APP changes retained",
    "pq.syncState.missing": "Missing in FileMaker · APP data retained",
    "pq.syncState.uncertain": "Create unconfirmed · Needs reconciliation",
    "pq.syncState.review": "Legacy changes · Needs review",
    "pq.syncState.pending_delete": "Deletion pending",
    "pq.syncState.deleted": "Deleted",
    "pq.syncCounts": "Pending: {p} · Needs attention: {a}",
    "pq.createdOk": "New quote created",
    "pq.required": "required",
    "pq.pickFromProducts": "Load from Products",
    "pq.pickHint": "Auto-fill item number, name & size from an existing product",
    "pq.pickSearchPlaceholder": "Search item number or description...",
    "pq.pickEmpty": "No matching products",
    "pq.pickFilled": "Filled from product",
    "pq.editTitle": "Edit Procurement Quote",
    "pq.autoSaveHint": "Changes save automatically",
    "pq.autoSaving": "Saving…",
    "pq.autoSaved": "Saved automatically",
    "pq.updatedOk": "Quote updated",
    "pq.edit": "Edit",
    "pq.editDisabledHint": "You can only edit web-created quotes where 业务员 is you",
    "pq.duplicate": "Duplicate to today",
    "pq.duplicatedOk": "Duplicated to today's quote",
    "pq.saveAsCopy": "Save as copy",
    "pq.copiedOk": "Saved as a new record",
    "pq.newRecordBadge": "New record",
    "pq.tag": "Tag",
    "pq.resizeHint": "Drag to resize · double-click to auto-fit",
    "pq.columnWidths": "Column Widths",
    "pq.columnWidthsDesc": "Type an exact pixel value for each column, or reset to defaults. Changes persist per user.",
    "pq.columnWidthsHideHint": "Tip: set a column's width to 0 to hide it entirely.",
    "pq.columnWidthsResetAll": "Reset all",
    "pq.tagAction": "Set tag",
    "pq.tagPrompt": "Tag (leave empty to clear):",
    "pq.tagSaved": "Tag saved",
    "pq.editMode": "Inline Edit",
    "pq.editModeOn": "Inline edit mode ON — click any cell in your rows to edit; changes auto-save on blur.",
    "pq.editModeOff": "Inline edit mode off",
    "pq.autoSaved": "Auto-saved",
    "pq.autoSaveFailed": "Auto-save failed",
    "pq.invalidNumber": "Invalid number",
    "pq.history": "History",
    "pq.historyModalTitle": "Change History — {item}",
    "pq.historyKind": "Kind",
    "pq.historyKindCurrent": "Current",
    "pq.historyKindHistory": "History",
    "pq.historyChangedAt": "Change Time",
    "pq.historyChangedBy": "Changed By",
    "pq.historyAction": "Action",
    "pq.historyActionUpdate": "update",
    "pq.historyActionTag": "tag",
    "pq.historyActionDelete": "delete",
    "pq.historyEmptyList": "No history records for this product yet.",
    "pq.historyButton": "Procurement Quotes",
    "pq.historyTitle": "Procurement Quote Records",
    "pq.historyEmpty": "No procurement quote records match this product's buyer item number.",
    "pq.copyColHeader": "Copy",
    "pq.copyRow": "Copy this record",
    "pq.copied": "Copied — edit cells then click away to save",
    "pq.copyFailed": "Copy failed",
    "pq.saveFailed": "Save failed",
    "pq.filter": "Filter",
    "pq.minPrice": "Min price",
    "pq.maxPrice": "Max price",
    "pq.dateFrom": "Date from",
    "pq.dateTo": "Date to",
    "pq.importSelected": "Import to Price List",
    "pq.imported": "Imported {n} row(s) to the product price list",
    "pq.sync": "Sync FileMaker",
    "pq.otherDetails": "Other cost details",
    "pq.otherDetailName": "Name",
    "pq.otherDetailAmount": "Amount",
    "pq.otherDetailAdd": "Add a row",
    "pq.otherDetailsEmpty": "No details yet — click \"Add a row\"",
    "pq.otherDetailFmLocked": "This row is synced from FileMaker and cannot be edited here",
    "pq.otherDetailFmNote": "Locked rows come from FileMaker (其他 / 其他1 / 其他2 / 其他3) — edit them in FM",
    "pq.otherDetailsTotal": "Total (fills 其他)",
    "pq.othersLockedHint": "from details",
    "pq.backfillQtyHq": "Fill missing QTY/HQ",
    "pq.backfillQtyHqDone": "QTY/HQ filled for {n} records",
    "pq.syncTitle": "Procurement Quotes Sync (FileMaker · two-way)",
    "pq.syncHint": "Field-level sync with version checks. Preview: current month; production: configured start date through today. Pending APP changes and conflicts are never silently overwritten.",
    "pq.syncing": "Syncing",
    "pq.syncDone": "Sync complete: {n} records updated",
    "pq.syncPushSummary": "· pushed {c} new, {u} updated, {d} deleted",
    "pq.empty": "No procurement quotes. Click Sync to import from FileMaker.",
    "pq.pageInfo": "Page {page} / {pages}",
    "pq.prev": "Prev",
    "pq.next": "Next",
    "pq.date": "Date",
    "pq.quoteCustomer": "Customer",
    "pq.productPhoto": "Photo",
    "pq.quoteDate": "Quote Date",
    "pq.itemNumber": "Item No.",
    "pq.nameCn": "Product Name",
    "pq.size": "Size",
    "pq.thickness": "Product Spec",
    "pq.factory": "Factory",
    "pq.price": "Price",
    "pq.sectionBasic": "Basic info",
    "pq.sectionPrice": "Price info",
    "pq.sectionCarton": "Carton data",
    "pq.priceFormulaHint": "Price = (price/m x material size + fees + others + others 1/2/3) x (1 + profit & tax)",
    "pq.pricePerMeter": "Price/Meter",
    "pq.materialSize": "Material Size",
    "pq.processingFee": "Processing Fee",
    "pq.brandPaper": "Brand Paper",
    "pq.plasticBag": "Plastic Bag",
    "pq.linerBoard": "Liner Board",
    "pq.cartonFreight": "Carton Freight",
    "pq.profitTax": "Profit & Tax",
    "pq.others": "Others",
    "pq.others123": "Others 1/2/3",
    "pq.packingRate": "Packing Rate",
    "pq.length": "L",
    "pq.width": "W",
    "pq.height": "H",
    "pq.qtyHq": "QTY HQ",
    "pq.grossWeight": "Gross weight",
    "upcSync.title": "UPC library (FileMaker UPC_API)",
    "upcSync.hint": "One-way nightly pull (06:30) of every UPC code from FileMaker so the UPC lookup in the quote editor is up to date. Run it manually after adding codes directly in FileMaker.",
    "upcSync.sync": "Sync now",
    "upcSync.running": "Syncing",
    "upcSync.started": "UPC sync started",
    "upcSync.stored": "codes stored:",
    "upcSync.lastRun": "last run",
    "sample.manage": "Sample management",
    "sample.pageHint": "Every sample list is shared with the team. Search by name, customer or created date.",
    "sample.newList": "New list",
    "sample.create": "Create",
    "sample.search": "Search",
    "sample.searchPlaceholder": "List name / customer / receipt no. / creator",
    "sample.customer": "Customer",
    "sample.customerAny": "Any customer",
    "sample.customerPlaceholder": "Pick or type a customer name",
    "sample.receiptNo": "Receipt No.",
    "sample.receiptNoPlaceholder": "Enter the receipt no.",
    "sample.createdRange": "Created between",
    "sample.clear": "Clear",
    "sample.listName": "List name",
    "sample.qtyProducts": "Products",
    "sample.createdAt": "Created",

    "sample.selected": "{n} selected",
    "sample.addTitle": "Add {n} products to a sample list",
    "sample.newName": "New sample list name",
    "sample.namePlaceholder": "e.g. GT Sept sample shipment",
    "sample.createAndAdd": "Create & add",
    "sample.orExisting": "or add to an existing list",
    "sample.added": "{n} added, {s} already in the list",
    "sample.nameRequired": "Please enter a sample list name",
    "sample.listsTitle": "Sample lists",
    "sample.noLists": "No sample lists yet — pick products in the grid and use Action → Sample management.",
    "sample.noItems": "This list is empty",
    "sample.count": "{n} products",
    "sample.createdBy": "created by",
    "sample.rename": "Rename",
    "sample.renamePrompt": "New name for this sample list:",
    "sample.delete": "Delete list",
    "sample.deleteConfirm": "Delete sample list \"{name}\" and all its products?",
    "sample.deleted": "Sample list deleted",
    "sample.export": "Export Excel",
    "sample.itemNo": "Item no",
    "sample.name": "Product name",
    "sample.qty": "Qty",
    "sample.remark": "Remark",
    "sample.remarkPlaceholder": "Remark (auto-saved)",
    "upc.button": "UPC lookup",
    "upc.title": "UPC lookup · from FileMaker",
    "upc.importInto": "Import into row",
    "upc.noRows": "No size rows yet",
    "upc.unnamedSize": "(no size)",
    "upc.search": "Search",
    "upc.searchPlaceholder": "Item number, description or UPC",
    "upc.itemNo": "Item no",
    "upc.description": "Description",
    "upc.code": "UPC (12 digits)",
    "upc.pageTitle": "UPC Lookup",
    "upc.clearFilters": "Clear",
    "upc.dateCreated": "Created",
    "upc.use": "Use",
    "upc.empty": "No matching UPC found",
    "upc.imported": "UPC {code} filled into the row",
    "upc.pickRowFirst": "Pick a target size row first",
    "upc.newTitle": "Create a new UPC",
    "upc.seq5": "5-digit sequence",
    "upc.finalPreview": "Full UPC:",
    "upc.checkDigitHint": "last digit auto-calculated (UPC-A)",
    "upc.createAndImport": "Create & import",
    "upc.created": "UPC {code} created in FileMaker",
    "pq.realtimeHint": "APP saves push immediately; platform pulls FileMaker and retries pending changes every {n} minutes.",
    "pq.realtimeField": "Incremental key",
    "pq.realtimeLast": "last incremental",
    "pq.qtyHqAuto": "auto",
    "common.prev": "Prev",
    "common.next": "Next",
    "pq.salesperson": "Salesperson",
    "pq.remark": "Remark",
    "factories.title": "Factories",
    "factories.name": "Factory Name",
    "factories.contactPerson": "Contact Person",
    "factories.email": "Email",
    "factories.phone": "Phone",
    "factories.buyer": "Buyer in Charge",
    "factories.noFactories": "No factories yet",
    "factories.searchPlaceholder": "Search factory / contact / buyer",
    "factories.pickFactoryHint": "Pick a factory on the left to see its products",
    "factories.editDetails": "Edit details",
    "factories.noProducts": "No products linked to this factory",
    "common.page": "page",
    "factories.newTitle": "New Factory",
    "factories.editTitle": "Edit Factory",
    "products.factory": "Factory",
    "priceList.qty40": "QTY/40HQ",
    "priceList.usPrice": "US Price",
    "priceList.cadPrice": "Price",
    "customers.title": "Customers",
    "customers.seller": "Export Sales (外销)",
    "customers.newTitle": "New Customer",
    "customers.editTitle": "Edit Customer",
    "customers.name": "Customer Name",
    "customers.email": "Contact Email",
    "customers.contactPerson": "Contact Person",
    "customers.address": "Address",
    "customers.destinationPort": "Destination Port",
    "customers.paymentTerms": "Payment Terms",
    "customers.noCustomers": "No customers yet. Click New to create one.",
    "nav.settings": "Settings",
    "nav.users": "Users",
    "nav.logout": "Log out",
    "nav.hideSidebar": "Hide menu",
    "nav.showSidebar": "Show menu",
    "nav.userMenu": "User menu",
    "nav.changePassword": "Change Password",
    "nav.menu": "Menu",
    "nav.more": "More",
    "nav.admin": "Admin",
    "changePw.hint": "Enter your current password, then set a new one (min 6 chars).",
    "changePw.oldPassword": "Current Password",
    "changePw.newPassword": "New Password",
    "changePw.confirmPassword": "Confirm New Password",
    "changePw.submit": "Update Password",
    "changePw.success": "Password updated",
    "changePw.tooShort": "New password must be at least 6 characters",
    "changePw.mismatch": "New passwords do not match",
    "changePw.sameAsOld": "New password must differ from the current one",
    "login.toggleLanguage": "Switch language",
    "login.title": "Sign in to Product Library",
    "login.subtitle": "Quotation & Pricing Management",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign In",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.back": "Back",
    "common.close": "Close",
    "common.delete": "Delete",
    "common.remove": "Remove",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.search": "Search item number or description...",
    "common.loading": "Loading...",
    "common.actions": "Actions",
    "common.confirmDelete": "Are you sure? This cannot be undone.",
    "common.all": "All",
    "common.clearFilters": "Clear Filters",
    "products.title": "Products",
    "products.justImportedBanner": "Showing {n} just-imported product(s)",
    "products.clearImportedFilter": "Show All Products",
    "import.viewImported": "View Imported Products",
    "products.new": "New Product",
    "products.editTitle": "Edit Product",
    "products.newTitle": "New Product",
    "products.itemNumber": "Item Number",
    "products.description": "Description (English)",
    "products.gtDescription": "GT Description",
    "products.gtDescriptionHint": "Short display name (max 30 chars). Used in downloaded quote / label filenames. Auto-filled from description.",
    "products.descriptionZh": "Description (Chinese)",
    "products.specification": "Specification (English)",
    "products.specificationZh": "Specification (Chinese)",
    "products.photo": "Product Photo",
    "products.tagsLabel": "Tags",
    "products.noPhoto": "No photo",
    "products.factoryQuotePhoto": "Factory Quote Photo",
    "products.uploadPhoto": "Upload Photo",
    "products.zoomPhoto": "Zoom",
    "products.newBadge": "NEW",
    "products.newProducts": "New (2W)",
    "products.newOnly": "New only",
    "products.allProducts": "All products",
    "products.newOnlyHint": "Show products created in the last {n} days plus any product with no type set (window configurable in Settings)",
    "products.newProductDays": "New-product window (days)",
    "products.newProductDaysHint": "Products whose creation date is within this many days are flagged as new",
    "products.appCreationDate": "Created in app",
    "products.newProductsHint": "Show products created in the last 2 weeks, sorted by category",
    "products.priceRange": "Price Range",
    "products.noProducts": "No products yet. Create your first one.",
    "products.photoUpdated": "Product photo updated",
    "products.category": "Category",
    "products.subcategory": "Subcategory",
    "products.brand": "Brand",
    "products.buyer": "Buyer",
    "products.seller": "Sales",
    "products.tag": "Tag",
    "quote.exportExcel": "Export Excel",
    "quote.fullscreen": "Fullscreen product list",
    "quote.exitFullscreen": "Exit fullscreen",
    "pq.fullscreen": "Fullscreen",
    "quote.editor.itemNumberSaved": "Item number updated (this quote only)",
    "quote.editor.originalItemNumber": "Original item no.",
    "plink.action": "Generate link",
    "plink.title": "Generate product share link",
    "plink.selected": "{n} product(s) selected",
    "plink.titleLabel": "Link title (optional)",
    "plink.titlePlaceholder": "e.g. Spring 2026 New Arrivals",
    "plink.validity": "Validity",
    "plink.days": "{n} days",
    "plink.forever": "Never expires",
    "plink.generate": "Generate",
    "plink.shareLink": "Share link",
    "plink.embedCode": "Embed code (iframe)",
    "plink.copied": "Copied",
    "plink.resultMeta": "{n} products · valid until {exp}",
    "plink.rulesHint": "Anonymous visitors see photo, item number and English description only. Signed-in users also see USD prices (base price × their price coefficient). The page is English only.",
    "pq.sinceLabel": "Sync start date",
    "pq.sinceHint": "MM/DD/YYYY — end date is always today; affects manual/full sync only",
    "pq.exitFullscreen": "Exit fullscreen",
    "pq.mobileFilters": "Filters",
    "pq.mobileFieldsTitle": "Fields on card",
    "pq.takePhoto": "Photo",
    "pq.photoUploaded": "Product photo updated",
    "pq.loadMore": "Load more",
    "quote.emailQuote": "Email Quote",
    "quote.emailSending": "Sending...",
    "quote.emailSent": "Quote emailed to",
    "quote.emailError": "Failed to send email",
    "quote.exportPdf": "Export PDF",
    "quote.printLabels": "Print Labels",
    "quote.exportError": "Export failed",
    "quote.exportSuccess": "Export downloaded",
    "quote.exportCustomerTemplate": "Customer Quotation",
    "quote.customerTemplateNone": "Customer '{name}' has no quote template — upload one in the Customers page first.",
    "quote.customerTemplatePickHint": "This customer '{name}' has multiple templates. Pick which one to fill.",
    "quote.selectAllRows": "Select / deselect all price rows for export",
    "quote.colDragHint": "Drag the header to reorder this column",
    "quote.freightShort": "Freight",
    "quote.pricingParams": "Pricing parameters",
    "quote.paramCurrency": "Currency",
    "quote.paramFx": "Quote rate US$→¥",
    "quote.paramCadFx": "Rate US$→C$",
    "quote.paramFreight": "Ocean freight / 40HQ",
    "quote.paramProfit": "Profit margin",
    "quote.paramMultiplier": "Price multiplier",
    "quote.paramPerProductHint": "Duty and tax rebate are read per product from its live record.",
    "quote.paramFormulaUsd": "Calc price = RMB factory cost ÷ quote rate (rounded up to 0.05)",
    "quote.paramFormulaCad": "Calc price = (USD cost × (1+duty) + freight ÷ 40HQ qty) ÷ (1-margin) × US$→C$ × multiplier",
    "quote.colOrderReset": "Reset column order",
    "quote.editor.title": "Product detail (this quote only)",
    "quote.editor.openHint": "Click to edit this product's details for this quote",
    "quote.editor.noItems": "No products in this quote yet. Add products first.",
    "quote.editor.loading": "Loading… if this persists, close and click again.",
    "quote.editor.rowAdded": "Size added",
    "quote.editor.rowsImported": "Imported {n} procurement quote row(s)",
    "quote.editor.rowDeleted": "Row deleted",
    "quote.editor.deleteRow": "Delete this size row",
    "quote.editor.confirmDeleteRow": "Delete this size row?",
    "quote.removeItem": "Remove this product from the quote",
    "quote.editor.prev": "Prev",
    "quote.editor.next": "Next",
    "quote.editor.photo": "Photo",
    "quote.editor.uploadPhoto": "Upload photo",
    "quote.editor.resetPhoto": "Reset to product photo",
    "quote.editor.similarPhotos": "Similar photos from Product Overview",
    "quote.editor.photoLibrary": "Similar photos (products / overview / market)",
    "quote.editor.photoLibraryShort": "Similar photos",
    "quote.editor.searchAllPhotos": "Search products, overview and market photos",
    "quote.editor.src.product": "Products",
    "quote.editor.src.overview": "Overview",
    "quote.editor.src.market": "Market",
    "quote.editor.searchOverviewPhotos": "Search all overview photos (item # / description)",
    "quote.editor.noOverviewPhotos": "No matching photo",
    "quote.editor.override": "Override",
    "quote.editor.description": "Description",
    "quote.editor.gtDescription": "GT Description (short)",
    "quote.editor.gtGenerating": "AI is generating…",
    "quote.editor.gtLengthWarning": "GT description is {n} characters — over 30. Consider shortening it.",
    "quote.editor.specMaterial": "Specification & Material",
    "quote.editor.buyerPlaceholder": "Select buyer…",
    "quote.editor.inquire": "Send to buyer",
    "quote.editor.buyerQuoted": "Buyer has quoted",
    "quote.editor.procurementNote": "Procurement Quote Brief",
    "quote.editor.procurementNotePlaceholder": "What the buyer should quote on (material, packing, MOQ, target price…)",
    "quote.editor.generateLink": "Generate link",
    "quote.editor.linkNeedsBuyer": "Select the buyer (采购) for this product first",
    "quote.editor.linkTitle": "Procurement link created",
    "quote.editor.linkHint": "Send this link to {buyer} — it opens the {n} product(s) of this quote assigned to them. They must log in as 采购.",
    "quote.editor.linkCopy": "Copy",
    "quote.editor.linkCopied": "Link copied",
    "quote.editor.linkExpires": "Valid until {date} (30 days)",
    "procReq.priceRows": "Price details (imported from procurement quotes)",
    "procReq.factoryCost": "Factory cost",
    "procReq.tabPrice": "Quote",
    "procReq.tabPacking": "Packing",
    "procReq.moq": "MOQ",
    "procReq.qtyPerCtn": "Qty/CTN",
    "procReq.caseSize": "Carton L×W×H",
    "procReq.containerQty": "40HQ qty",
    "procReq.noRows": "No price rows yet — open the procurement records and import",
    "procReq.deleteRow": "Delete row imported today",
    "procReq.markDone": "Mark quoted",
    "procReq.moqRequired": "Please fill in the MOQ first",
    "procReq.markedDone": "Marked as quoted",
    "procReq.notDoneYet": "Quotation not completed yet",
    "procReq.imported": "{n} row(s) imported",
    "pq.newRecord": "New record",
    "procReq.title": "Procurement Quote Request",
    "procReq.expires": "Valid until {date}",
    "procReq.empty": "No products on this quote are assigned to you",
    "procReq.noNote": "No brief provided",
    "procReq.fileQuote": "File procurement quote",
    "procReq.submitted": "Procurement quote saved",

    "quote.editor.specification": "Specification",
    "quote.editor.material": "Material",
    "quote.editor.priceRows": "Price rows (per size)",
    "quote.editor.dragToSort": "Drag to reorder",
    "quote.editor.noRows": "No price rows on this item",
    "quote.editor.saveAndClose": "Save & close",
    "quote.editor.autoSaveHint": "Changes will auto-save when you navigate or close",
    "quote.editor.snapshotHint": "Edits here only apply to this quote — the source product is never modified",
    "quote.editor.saveFailed": "Save failed",
    "quote.editor.uploadFailed": "Photo upload failed",
    "quote.editor.col.size": "Size",
    "quote.editor.col.customer_price": "Calc. price",
    "quote.editor.writeBack": "Write back to product",
    "quote.editor.duplicated": "Product copied in this quote (price rows included)",
    "quote.editor.writeBackConfirm": "Write this quote's price rows (cost, cartons, container qty), compression rate and duty back to the product database? Final Price is NOT written back. Existing sizes are updated, new sizes are added, and product rows missing here are left untouched.",
    "quote.editor.writeBackDone": "Written back to product — {updated} updated, {created} added",
    "quote.editor.col.upc": "UPC",
    "quote.editor.col.final_price": "Final Price",
    "quote.editor.col.factory_cost": "Factory Cost",
    "quote.editor.col.factory_cost_usd": "Factory Cost US$",
    "quote.editor.col.case_length": "Case L (cm)",
    "quote.editor.col.case_width": "Case W (cm)",
    "quote.editor.col.case_height": "Case H (cm)",
    "quote.editor.col.case_weight": "Case Wt (kg)",
    "quote.editor.col.qty_per_ctn": "Qty/Ctn",
    "quote.editor.col.container_qty_40": "40FT Ctnr Qty",
    "quote.editor.col.compression_rate": "Compression",
    "quote.editor.col.container_qty_40_compressed": "Qty after comp.",
    "products.selectAll": "Select All",
    "products.searchPlaceholder": "Search item no / buyer no / description / tag",
    "products.creationDateFilter": "Creation Date",
    "products.factoryCostFilter": "Factory Cost",
    "products.sellingPriceFilter": "Selling Price",
    "products.min": "min",
    "products.filters": "Filters",
    "products.loadMore": "Load more",
    "products.max": "max",
    "products.prevProduct": "Previous",
    "products.nextProduct": "Next",
    "products.autoSaveHint": "Changes are saved automatically",
    "dup.title": "Find Duplicates",
    "dup.hint": "Products with identical or near-identical item numbers. Tick the ones to remove.",
    "dup.none": "No duplicate products found",
    "dup.exact": "Identical item number",
    "dup.similar": "Similar item number",
    "dup.priceRows": "Price rows",
    "dup.deleteSelected": "Delete Selected",
    "dup.confirmTitle": "Delete these products?",
    "dup.deleted": "Deleted",
    "products.deselectAll": "Deselect All",
    "products.clearSelection": "Clear selection",
    "products.actions": "Actions",
    "products.setTag": "Set Tag",
    "products.gridPdf": "Grid View PDF",
    "products.gridPdfTitle": "Product Catalog",
    "products.perPage": "Per page",
    "scanner.title": "Scan item number",
    "scanner.hint": "Point the barcode / QR code at the viewfinder — detection is automatic. No barcode? Use the OCR button below.",
    "scanner.ocrHint": "Snap a label with the SKU printed on it — the AI reads it and fills the search box.",
    "scanner.ocrSubhint": "Tap the button to open the camera. No code or blurry? Switch to live scan or type manually.",
    "scanner.ocrFrameHint": "Align the SKU inside the box and tap the round button. Only the box is read — faster and more accurate.",
    "scanner.alignHint": "Align SKU inside the box, then tap shutter",
    "scanner.capture": "Capture",
    "scanner.recognizing": "Recognizing…",
    "card.title": "Scan business card",
    "card.hint": "Place the card inside the frame and tap the shutter — AI fills the customer form.",
    "card.alignHint": "Align the card inside the frame, then tap shutter",
    "card.recognized": "Business card recognized",
    "card.notRecognized": "No info detected — align the card inside the frame and retry.",
    "customers.scanCard": "Scan card to auto-fill",
    "customers.saveAndNewQuote": "Save + New quote",
    "customers.phone": "Phone",
    "customers.title_label": "Job Title",
    "customers.website": "Website",
    "customers.importance": "Importance",
    "customers.importanceAiOnly": "AI-rated based on business card. Not manually editable.",
    "customers.importanceReason": "AI reason",
    "customers.customerType": "Customer Type",
    "customers.assessmentReport": "Customer Assessment Report",
    "customers.showReport": "Show full assessment report",
    "customers.hideReport": "Hide",
    "customers.filterByImportance": "Filter by importance",
    "customers.allImportance": "All ratings",
    "customers.sortByImportance": "Sort by importance",
    "customers.notRated": "Not rated",
    "customerType.chain": "Chain Store",
    "customerType.importer": "Importer",
    "customerType.retailer": "Retailer",
    "customerType.wholesaler": "Wholesaler",
    "customerType.agent": "Agent",
    "customerType.unknown": "Unknown",
    "importance.5": "Key Account",
    "importance.4": "Important",
    "importance.3": "Potential",
    "importance.2": "Normal",
    "importance.1": "Watch",
    "scanner.manualHint": "Type an item number and press Enter.",
    "scanner.starting": "Starting camera…",
    "scanner.live": "Scan",
    "scanner.ocr": "OCR photo",
    "scanner.manual": "Type",
    "scanner.manualPlaceholder": "Enter item number…",
    "scanner.cameraDenied": "Camera unavailable — check permissions or use the OCR photo option.",
    "scanner.permDenied": "Allow camera access in your browser settings and try again.",
    "scanner.noCamera": "No usable camera detected on this device.",
    "scanner.cameraBusy": "Camera is in use by another app — close it and retry.",
    "scanner.recognized": "Recognized",
    "scanner.notRecognized": "No code recognized — try a clearer picture or type manually.",
    "scanner.ocrFailed": "OCR failed",
    "scanner.filled": "Filled into search",
    "po.batch.deleteConfirm": "Delete {n} selected product-overview record(s)? This cannot be undone.",
    "po.batch.needItemNumber": "Selected records have no item number — cannot run this action.",
    "po.batch.addToQuoteDone": "Added to quote",
    "po.batch.failed": "Failed",
    "products.customerQuote": "Download Customer Quote",
    "products.customerQuoteDesc": "Fill the customer's uploaded template with {n} selected product(s).",
    "products.downloadExcel": "Download Excel",
    "customers.quoteTemplate": "Quote Template (Excel)",
    "customers.quoteTemplateHint": "Upload .xlsx / .xlsm templates. Use placeholders like {{customer.name}}, {{product.item_number}}, {{row.customer_price}}, {{product.photo}}. Multiple templates supported.",
    "customers.templateUpload": "Upload template",
    "customers.templateUploaded": "Template",
    "customers.templateReplace": "Replace",
    "customers.templateSaved": "Template saved",
    "customers.templateXlsxOnly": "Only .xlsx files are supported",
    "customers.templateReady": "Template ready",
    "customers.templateMissing": "No template",
    "customers.pickTemplate": "Choose template",
    "customers.noTemplatesAny": "No customer has uploaded a template yet. Upload one in the Customers page.",
    "customers.templateManage": "Manage templates",
    "customers.templateAdd": "Add template",
    "customers.templateAttached": "Template attached to customer",
    "customers.attachTemplateTitle": "Attach a quote template",
    "customers.attachTemplateHint": "Pick a template from the shared catalog. Admins manage the catalog centrally.",
    "customers.noSystemTemplates": "No system templates available yet. Ask an admin to upload one.",
    "customers.templateNamePrompt": "Name this template (e.g. GT Quote):",
    "customers.templateCheck": "Check placeholders",
    "templateAnalysis.title": "Template compatibility check",
    "templateAnalysis.allClean": "All placeholders in this template are recognised. Exports will fill correctly.",
    "templateAnalysis.issuesFound": "Some placeholders may not fill correctly. Review the details below.",
    "templateAnalysis.known": "known",
    "templateAnalysis.typos": "typos",
    "templateAnalysis.unknown": "unknown",
    "templateAnalysis.photos": "photos",
    "templateAnalysis.sheets": "sheets",
    "templateAnalysis.placeholders": "placeholders",
    "templateAnalysis.typosHeader": "Likely typos — did you mean…?",
    "templateAnalysis.typosHint": "These tokens look like known fields with a spelling issue. Replace them in your template file.",
    "templateAnalysis.unknownHeader": "Unknown placeholders",
    "templateAnalysis.unknownHint": "These tokens don't match any known field. Cells will be left blank at export time.",
    "templateAnalysis.sheetsHeader": "Sheets breakdown",
    "templateAnalysis.autofix": "One-click fix typos",
    "templateAnalysis.autofixConfirm": "Rewrite {count} typo placeholder(s) in this template? The file will be saved in place.",
    "templateAnalysis.autofixSuccess": "Fixed {count} placeholder(s)",
    "templateAnalysis.autofixFailed": "Auto-fix failed",
    "templateAnalysis.autofixNothing": "No typos to fix",
    "nav.systemTemplates": "System Templates",
    "nav.badImages": "Broken Photos",
    "badImg.title": "Broken Photo Scanner",
    "badImg.hint": "Checks every product photo (main / factory quote / pattern / composite) and lists the ones browsers can't render — legacy WMF containers, files that no longer exist, or renamed non-images. Runs in the background and can be stopped anytime.",
    "badImg.scan": "Start scan",
    "badImg.scanning": "Scanning",
    "badImg.scanStarted": "Scan started",
    "badImg.stop": "Stop",
    "badImg.stopRequested": "Stopping after the current record…",
    "badImg.never": "Never scanned",
    "badImg.lastRun": "Last run",
    "badImg.checked": "photos checked",
    "badImg.found": "broken",
    "badImg.listCount": "{n} broken photos listed",
    "badImg.colPreview": "Preview",
    "badImg.colField": "Photo slot",
    "badImg.colReason": "Reason",
    "badImg.fieldPhoto": "Product photo",
    "badImg.fieldFactoryQuote": "Factory quote photo",
    "badImg.fieldPattern": "Pattern photo",
    "badImg.fieldComposite": "Composite photo",
    "badImg.reason_unsupported_format": "Unsupported format (WMF etc.)",
    "badImg.reason_missing_file": "File no longer exists",
    "badImg.reason_undecodable": "Not a readable image",
    "badImg.fix": "Re-pull original from FileMaker",
    "badImg.fixed": "Photo restored from FileMaker",
    "badImg.fixFailed": "Could not fix automatically",
    "badImg.dismiss": "Remove from list",
    "badImg.empty": "No broken photos — run a scan to check again.",
    "systemTemplates.title": "System Quote Templates",
    "systemTemplates.subtitle": "Shared quote template library — customers attach these when generating quotes.",
    "systemTemplates.uploadButton": "Upload Template",
    "systemTemplates.uploadTitle": "Upload new system template",
    "systemTemplates.uploadHint": "Only .xlsx or .xlsm files, up to 8 MB.",
    "systemTemplates.nameLabel": "Display name",
    "systemTemplates.namePlaceholder": "e.g. GT报价单",
    "systemTemplates.fileLabel": "Template file",
    "systemTemplates.uploaded": "Template uploaded",
    "systemTemplates.uploadFailed": "Upload failed",
    "systemTemplates.deleted": "Template deleted",
    "systemTemplates.deleteConfirm": "Delete template \"{name}\"? Customers already using it will need to pick another.",
    "systemTemplates.renamed": "Template renamed",
    "systemTemplates.renameTitle": "Rename template",
    "systemTemplates.empty": "No templates uploaded yet. Add one to get started.",
    "systemTemplates.analyze": "Analyze",
    "systemTemplates.rename": "Rename",
    "systemTemplates.delete": "Delete",
    "systemTemplates.download": "Download",
    "systemTemplates.uploadedBy": "Uploaded by",
    "systemTemplates.uploadedAt": "Uploaded at",
    "customers.empty": "No customers yet.",
    "products.tagPrompt": "Tag will be applied to all selected products. Leave empty to clear.",
    "products.tagApplied": "Tag applied",
    "products.copy": "Copy Product",
    "products.copied": "Products copied",
    "products.sectionIdentity": "Identity",
    "products.sectionMedia": "Photos",
    "products.sectionDescription": "Description & Spec",
    "products.sectionClassification": "Classification & Factory",
    "products.patternPhoto": "Pattern Photo",
    "products.compositePhoto": "Composite Image",
    "products.photoEdit": "Photo Edit",
    "products.autoSaved": "Auto-saved",
    "products.compositeEmpty": "Generate to combine product + pattern photos",
    "products.generateComposite": "Generate Composite",
    "products.compositeGenerated": "Composite image generated",
    "products.uploadPatternPhoto": "Upload Pattern Photo",
    "products.tagList": "Tag List",
    "products.tagListTitle": "Tag Management",
    "products.tagListDesc": "All tags in the product catalog. Rename or delete tags in bulk across every product.",
    "products.tagListEmpty": "No tags in use yet.",
    "products.tagListExpand": "Expand",
    "products.tagListCollapse": "Collapse",
    "products.tagListCount": "products",
    "products.tagListSearch": "Search tags...",
    "products.tagRename": "Rename",
    "products.tagRenameTitle": "Rename Tag",
    "products.tagRenameNew": "New tag name",
    "products.tagRenamed": "Tag renamed",
    "products.tagMergeTitle": "Merge Tags?",
    "products.tagMergeDesc": "The tag \"{name}\" already exists on {count} product(s). Merging will move all products from the source tag into the target tag. Continue?",
    "products.tagMerge": "Merge",
    "products.tagMerged": "Tags merged",
    "products.tagDeleteTitle": "Delete Tag?",
    "products.tagDeleteDesc": "The tag \"{name}\" is used by {count} product(s). Deleting will clear the tag from every product. Products themselves stay intact. Continue?",
    "products.tagDeleted": "Tag cleared from products",
    "products.deleteConfirm": "Move the selected products to the recycle bin? They can be restored within 30 days.",
    "products.deleted": "Deleted",
    "products.buyerItemNumber": "Buyer Item No.",
    "products.fmCreationDate": "FM Created",
    "products.trash": "Recycle Bin",
    "products.trashHint": "Deleted products are kept here for 30 days, then removed permanently. Restore returns them (with price lists) to the product list.",
    "products.trashEmpty": "Recycle bin is empty",
    "products.daysLeft": "Auto-purge in",
    "nav.trash": "Recycle Bin",
    "products.deletedAt": "Deleted At",
    "products.restore": "Restore",
    "products.restored": "Restored",
    "products.purged": "Permanently deleted",
    "products.purgeSure": "Delete forever?",
    "products.addedToQuote": "product(s) added to",
    "products.material": "Material",
    "products.sellingFeature": "Selling Feature",
    "products.sellingFeatureHint": "Marketing highlights, USP, key selling points…",
    "products.package": "Package",
    "products.moq": "MOQ",
    "quote.editor.moqPlaceholder": "e.g. 500 sets / 1x40HQ",
    "exportCols.title": "My export columns",
    "exportCols.button": "Export columns",
    "exportCols.hint": "Choose which columns appear in YOUR quote Excel / PDF exports. Other users keep their own choice. PHOTO and ITEM NO are always included.",
    "exportCols.save": "Save",
    "exportCols.saved": "Export columns saved",
    "exportCols.all": "Select all",

    "products.removeBg": "One-click cutout",
    "products.originalRestored": "Original photo restored",
    "products.restoreOriginal": "Restore original",
    "products.bgRemoving": "Processing...",
    "products.bgRemoved": "Background removed. Save to keep, or revert.",
    "products.revertBg": "Revert Photo",
    "products.bgReverted": "Photo reverted",
    "products.taxRebate": "Tax Rebate",
    "customers.currency": "Currency",
    "customers.priceMultiplier": "Price Multiplier",
    "customers.priceMultiplierHint": "Every quoted price for this customer is multiplied by this. Default: 1.0",
    "customers.profitRate": "Profit Rate",
    "customers.shippingFee": "Shipping Fee (40')",
    "quote.calcPrice": "Calc Price",
    "quote.currencyFromCustomer": "Currency & price multiplier come from the customer settings — the multiplier is applied to the base price at export",
    "settings.quoteExchangeRate": "USD/RMB Exchange Rate",
    "settings.exchangeRateHint": "美金兑人民币汇率 — used when factory cost was entered in RMB",
    "settings.usdToCadRate": "USD/CAD Exchange Rate",
    "settings.usdToCadRateHint": "美金兑加币汇率 — CAD customer prices are multiplied by this rate (default 1.4)",
    "settings.shippingFee": "Ocean Freight (USD / 40HQ)",
    "settings.shippingFeeHint": "Full-container ocean freight in USD; divided by QTY/40HQ per unit in the CAD display price",
    "settings.usdProfitRate": "USD Profit Rate",
    "settings.cadProfitRate": "CAD Profit Rate",
    "settings.profitRateHint": "Decimal, e.g. 0.3 = 30% — used for the reference price on the products page",
    "products.isStandard": "Standard Product",
    "products.productType": "Product Type",
    "products.stockQuantity": "Stock Qty",
    "quote.editor.stockPlaceholder": "e.g. 1200 pcs",
    "products.type_stock": "Stock Product",
    "products.type_mine": "Low MOQ Product",
    "products.type_standard": "Standard Product",
    "products.type_sample": "Sample Product",
    "productTypes.title": "Product Types",
    "productTypes.hint": "Manage the product-type dictionary shown in filters and forms. Default types can be renamed or disabled but not deleted.",
    "productTypes.codePlaceholder": "code",
    "productTypes.nameZh": "中文名称",
    "productTypes.nameEn": "English name",
    "productTypes.defaultBadge": "default",
    "productTypes.on": "on",
    "productTypes.off": "off",
    "productTypes.added": "Product type added",
    "productTypes.deleted": "Product type deleted",
    "productTypes.nameRequired": "Both Chinese and English names are required",
    "productTypes.confirmDelete": "Delete this product type? Products already tagged with it will show the raw code until you re-tag them.",
    "common.add": "Add",
    "products.showAll": "Show All",
    "products.showSelected": "Show Selected",
    "products.showSelectedEmptyHint": "Select products first",
    "products.viewList": "List view",
    "products.viewGrid": "Grid view",
    "products.densityCompact": "Compact",
    "products.densityComfortable": "Comfortable",
    "products.favoritesOnly": "My Favorites",
    "products.recentlyViewed": "Recently Viewed",
    "products.mineOnly": "My Products",
    "products.bulkFavorite": "Add to My Favorites",
    "products.addedToFavorites": "Added to favorites",
    "products.removedFromFavorites": "Removed from favorites",
    "products.readOnlyNotOwner": "Read-only: this product is assigned to another colleague — you can view but not edit it.",
    "products.rename": "Rename",
    "products.renameTitle": "Rename Item Number",
    "products.deleteTitle": "Move product to recycle bin",
    "products.deleteWarning": "\"{item}\" will be moved to the recycle bin and permanently deleted after 30 days. You can restore it before then from the recycle bin.",
    "products.deletedToTrash": "Product moved to recycle bin",
    "products.copyProduct": "Copy",
    "products.addToQuote": "Add to Quote",
    "products.pickActiveQuoteFirst": "Pick or create an active quote from the header first",
    "products.copiedTo": "Copied to",
    "products.copyFailed": "Copy failed",
    "products.renameWarning": "Changing the Item Number will also update its price list rows and price history. Existing quotations that already reference this Item Number will keep the OLD value as a historical snapshot.",
    "products.renameFrom": "Current",
    "products.renameTo": "New Item Number",
    "products.renameConfirm": "Rename",
    "products.renameSuccess": "Renamed successfully",
    "products.yes": "Yes",
    "products.no": "No",
    "products.inquiryTime": "Inquiry Time",
    "products.photoUploadTime": "Photo Upload Time",
    "products.autoTranslate": "Auto Translate to Chinese",
    "products.translating": "Translating...",
    "products.gridView": "Grid View",
    "products.listView": "List View",
    "products.typeOrSelect": "Type or select...",
    "products.select": "Select...",
    "products.duty": "Duty",
    "products.inquiryDate": "Inquiry Date",
    "products.addToQuote": "Add to Quotation",
    "products.importExcel": "Import Excel",
    "priceList.loadingRate": "Loading Rate",
    "priceList.usPrice": "US Price",
    "priceList.cadPrice": "Price",
    "priceList.containerQty": "40ft Qty",
    "priceList.finalPrice": "Final Price",
    "settings.title": "Global Settings",
    "settings.currency": "Quote Currency (币种)",
    "settings.subtitle": "Used to compute US Price and CAD Price. Last saved values apply until changed.",
    "settings.freight": "Freight (运费)",
    "settings.rateUr": "Exchange Rate UR (汇率UR)",
    "settings.rateUc": "Exchange Rate UC (汇率UC)",
    "settings.profitMargin": "Profit Margin (利润率)",
    "settings.saved": "Settings saved",
    "settings.formulas": "Price Formulas",
    "settings.options": "Option Lists (Buyer / Sales / Category)",
    "settings.optionsHint": "These options appear in the product form dropdowns. Add with Enter, remove with ×. Values already used on products remain available.",
    "settings.addOption": "Add option...",
    "settings.subcategoryPickCategory": "Category",
    "settings.subcategoryUnassigned": "Unassigned",
    "settings.usFormula": "US Price Formula",
    "settings.cadFormula": "CAD Price Formula",
    "settings.fields": "Available Fields (click to insert)",
    "settings.formulaHint": "Supported operators: + - * / ( ). Click a field to insert it into the focused formula.",
    "settings.preview": "Live Preview",
    "settings.sampleRow": "Sample row",
    "quote.title": "Quotations",
    "quote.activeQuote": "Currently editing this quote",
    "quote.new": "New",
    "quote.deleteRow": "Delete this size",
    "quote.created": "Quotation created",
    "quote.quoteNumber": "Quote #",
    "quote.copyQuote": "Copy quotation",
    "quote.copySharedQuote": "Copy this shared quotation into my own list",
    "quote.buyer": "Buyer",
    "quote.date": "Date",
    "quote.itemCount": "Products",
    "quote.customer": "Customer",
    "quote.customerName": "Customer Name",
    "quote.customerPlaceholder": "Select customer (optional)",
    "quote.customerFromModuleHint": "Options come from the Customers module — pricing uses the customer's currency / margin / freight",
    "quote.links.button": "Procurement links",
    "quote.links.title": "Procurement links",
    "quote.links.hint": "Links generated per buyer from the product editor. Valid 30 days; revoke any time.",
    "quote.links.empty": "No links generated for this quote yet",
    "quote.links.items": "{n} product(s)",
    "quote.links.submissions": "{n} filed",
    "quote.links.validUntil": "Valid until {date}",
    "quote.links.revoke": "Revoke",
    "quote.links.revoked": "Link revoked",
    "quote.links.revokedTag": "Revoked",
    "quote.links.expiredTag": "Expired",
    "quote.procFilled": "Buyer quoted {n}",
    "quote.procLinkSent": "Enquiry sent to buyer",
    "quote.filing.title": "What the buyer filed",
    "quote.filing.openHint": "Click to see the prices and carton data the buyer filed",
    "quote.filing.empty": "The buyer marked this product as filed, but no 采购报价 record is linked to this quote yet. Open the item editor to see the imported cost rows.",
    "quote.filing.log": "Filing log",
    "quote.filing.hint": "Read-only view of the buyer's 采购报价 records filed against this quote.",
    "quote.procLinkSentHint": "A procurement enquiry link for this product was sent on {date}",
    "quote.procFilledHint": "The buyer filed a procurement quote on {date}",
    "quote.exchangeRate": "Quote exchange rate (RMB→USD)",
    "quote.exchangeRateHint": "Leave empty to use the global rate ({rate}). USD price = RMB price ÷ this rate.",
    "quote.itemDragToSort": "Drag to reorder this product",
    "quote.customerNew": "New Customer",
    "quote.customerEdit": "Edit Customer",
    "quote.customerFreightUnset": "Not set",
    "quote.customerFreightLabel": "Freight",
    "quote.recomputePrices": "Recalculate",
    "quote.recomputePricesHint": "Recalculate every price from the current exchange rate / margin / freight / customer multiplier, then lock it again",
    "quote.recomputePricesDone": "Prices recalculated and locked",
    "quote.noQuoteSelected": "Select a quotation on the left or create a new one.",
    "quote.noBuyer": "No buyer",
    "quote.editTitle": "Edit Quotation",
    "quote.project": "Project",
    "quote.projectPlaceholder": "Project name (optional)",
    "quote.projectHint": "Type a new project name or pick from the existing list.",
    "quote.shareWithLabel": "Share with",
    "quote.shareQuoteHint": "Selected staff can view this quotation and, depending on the permission assigned, may also edit it. \"Read-only\" = view only; \"Read & Edit\" = view + edit.",
    "quote.sharePermissionRead": "Read-only",
    "quote.sharePermissionEdit": "Read & Edit",
    "quote.projectFilter": "Project",
    "quote.sellerFilter": "Sales",
    "quote.allSellers": "All sales",
    "quote.customerFilter": "Customer",
    "quote.scopeMine": "My Quotes",
    "quote.scopeAll": "All Quotes",
    "quote.allProjects": "All Projects",
    "quote.allCustomers": "All Customers",
    "quote.sharedBadge": "SHARED",
    "quote.sharedReadOnly": "Shared with you · read-only",
    "quote.sharedEditable": "Shared with you · you have edit access",
    "quote.shareTitle": "Share Project",
    "quote.shareProject": "Share",
    "quote.shareProjectHint": "Anyone you add here can VIEW and EXPORT every quote under this project. They cannot edit.",
    "quote.sharePickProject": "Pick a project",
    "quote.shareWithUsers": "Share with users",
    "quote.shareNoProject": "This quote has no project yet. Add a project name first to enable sharing.",
    "quote.shareNoUsers": "No users to share with.",
    "quote.shareSaved": "Share updated",
    "quote.shareRevoked": "Share revoked",
    "quote.shareCurrent": "Currently shared with:",
    "quote.shareRevoke": "Revoke",
    "quote.hideList": "Hide quote list",
    "quote.showList": "Show quote list",
    "quote.m.actions": "Actions",
    "quote.m.fields": "Card fields",
    "quote.m.editOnDesktop": "Editing prices is available on desktop.",
    "quote.replacePhoto": "Replace",
    "quote.hasOrder": "Has order",
    "quote.orderProgressHint": "Products with an order / total products",
    "quote.hasOrderBadge": "ORDER",
    "quote.orderNumber": "Order no.",
    "quote.resetPhoto": "Reset",
    "quote.photoReplaced": "Quote photo updated",
    "quote.noQuotes": "No quotations yet. Click New to create one.",
    "quote.empty": "Quotation is empty. Click Select Products to add.",
    "quote.selectProducts": "Select Products",
    "quote.selectingFor": "Selecting products for quotation",
    "quote.backToQuote": "Back to Quotation",
    "quote.switchQuote": "Quotation",
    "quote.pickQuote": "Select a Quotation",
    "quote.switchLatest": "Switch Quote (Latest 10)",
    "quote.allQuotes": "All Quotes",
    "quote.emptyListHint": "No quotes yet — click + New Quote below",
    "quote.size": "Size",
    "quote.photo": "Photo",
    "quote.description": "Description",
    "quote.specification": "Specification",
    "quote.caseSpec": "Case Spec (L×W×H)",
    "quote.qty": "40' HQ QTY",
    "quote.items": "items",
    "quote.addedTo": "Added to",
    "import.title": "Import Products from Excel",
    "import.hint": "Upload a quote form (.xlsx). Parse first, confirm the products, then import.",
    "import.previewHint": "Review the parsed products below. Nothing is imported until you confirm.",
    "import.format": "Excel format",
    "import.formatWise": "NINGBO WISE standard format",
    "import.formatBetterHome": "Better Home Fashion quote form",
    "import.formatUniversal": "Universal (map columns yourself)",
    "import.formatUniversalHint": "For any factory Excel — analyze headers, map columns, then import",
    "import.next": "Next",
    "import.sheet": "Sheet",
    "import.headerRow": "Header Row",
    "import.mapHint": "Map each Excel column to a product field. Fields left as \"— ignore —\" will not be imported.",
    "import.excelColumn": "Excel Column",
    "import.sampleValues": "Sample values",
    "import.mapTo": "Map to",
    "import.ignore": "ignore",
    "import.multiVariant": "Merge same-item rows into one product",
    "import.multiVariantHint": "Consecutive rows sharing / blanking the item number are treated as size / price variants",
    "import.needItemOrDesc": "Please map at least one column to Item Number or Description",
    "import.noSheets": "No usable sheets found in this file",
    "import.field.item_number": "Item Number",
    "import.field.description": "Description",
    "import.field.specification": "Specification",
    "import.field.material": "Material",
    "import.field.package": "Package",
    "import.field.moq": "MOQ",
    "import.field.photo": "Photo (embedded image)",
    "import.field.row_size": "Size",
    "import.field.row_price": "Factory Cost / Price",
    "import.field.qty_per_ctn": "Qty per Carton",
    "import.field.container_qty_40": "40'HQ Quantity",
    "import.field.cbm_ctn": "CBM per Carton",
    "import.field.case_length": "Carton Length",
    "import.field.case_width": "Carton Width",
    "import.field.case_height": "Carton Height",
    "import.field.case_weight": "Carton / Gross Weight",
    "import.field.duty": "Duty Rate",
    "import.preview": "Parse & Preview",
    "import.parsing": "Parsing...",
    "import.uploading": "Uploading",
    "fm.title": "FileMaker Sync",
    "fm.hint": "One-way sync from the FileMaker database (产品资料系统2023, layout: product) into this system. Existing products are updated, new ones created; photos are imported for products without one.",
    "fm.syncNow": "Sync Now",
    "fm.fixCreatedAt": "Fix creation dates",
    "fm.fixCreatedAtDone": "{n} products now use their FileMaker creation date",
    "fm.syncing": "Syncing",
    "fm.started": "Sync started",
    "fm.done": "Sync completed",
    "fm.failed": "Sync failed",
    "fm.created": "created",
    "fm.updated": "updated",
    "fm.photos": "photos",
    "fm.thumbs": "thumbs",
    "fm.priceRows": "price rows",
    "import.parsed": "Parsed products",
    "import.selectedCount": "Selected",
    "import.confirm": "Confirm Import",
    "import.exists": "Already exists",
    "import.prices": "Size · Price",
    "import.priceDetails": "Size · Price · Qty/CTN · CBM · 40'HQ",
    "import.selectAll": "Select all",
    "import.deselectAll": "Deselect all",
    "import.noPriceColumn": "No price column detected — prices may be 0",
    "import.dropzone": "Click to select an Excel file",
    "import.submit": "Import",
    "import.importing": "Importing...",
    "import.success": "Imported",
    "import.error": "Import failed",
    "import.imported": "Imported",
    "import.skipped": "Skipped",
    "import.replaced": "Replaced",
    "import.renamedFrom": "Renamed from",
    "import.overwriteDupes": "Overwrite duplicates (Admin)",
    "import.overwriteHint": "When ON, existing products with the same item number are wiped (product + all price rows) and replaced by the Excel data. Admin only.",
    "import.overwriteConfirm": "You are about to REPLACE {n} existing product(s). This cannot be undone. Continue?",
    "import.rows": "price rows",
    "import.costCurrency": "Factory cost currency in this Excel?",
    "import.productType": "Product Type (all imported products get this tag)",
    "import.productTypeNone": "None",
    "import.productTypeHint": "Optional. Pick from Settings → Product Types.",
    "import.category": "Product Category (all imported products get this category)",
    "rfq.toggleLabel": "RFQ Document",
    "rfq.toggleHint": "Upload a customer RFQ, AI will auto-fill the fields on the left.",
    "rfq.panelTitle": "RFQ Auto-Extract",
    "rfq.stepUpload": "Upload customer RFQ file",
    "rfq.stepPreview": "RFQ preview",
    "rfq.dropHere": "Click to upload Excel / PDF / PowerPoint / image",
    "rfq.reupload": "Re-upload",
    "rfq.reextract": "Re-extract",
    "rfq.done": "Extracted",
    "rfq.extracted": "Extraction complete",
    "rfq.error": "Extraction failed",
    "rfq.pdfNoPreview": "PDF uploaded — no in-browser preview, AI is extracting",
    "rfq.excelNoPreview": "Excel uploaded — AI is extracting",
    "rfq.pptNoPreview": "PowerPoint uploaded — AI is extracting",
    "rfq.unknownType": "Unsupported format",
    "import.categoryNone": "None",
    "import.categoryHint": "Optional. Options come from Settings → Categories.",
    "import.costUsd": "USD — import into Factory Cost (USD)",
    "import.costRmb": "RMB — import into Factory Cost",
    "priceList.title": "Product Price List",
    "priceList.addSize": "Add Size",
    "priceList.size": "Size",
    "priceList.compressionRate": "Compression",
    "priceList.qty40Compressed": "Qty after comp.",
    "priceList.importedFrom": "Imported by ",
    "priceList.qtyPerCtn": "PCS/CTN",
    "priceList.price": "Price",
    "priceList.factoryCost": "Factory Cost",
    "priceList.factoryCostUsd": "Factory Cost (USD)",
    "priceList.specification": "Spec",
    "priceList.toggleCostCurrency": "Toggle cost currency (RMB / USD)",
    "priceList.caseLength": "Case L",
    "priceList.caseWidth": "Case W",
    "priceList.caseHeight": "Case H",
    "priceList.caseWeight": "Case Wt",
    "priceList.quoteTime": "Quote Date",
    "priceList.pricePerMeter": "Price/Meter",
    "priceList.materialUsage": "Material Usage",
    "priceList.processingFee": "Processing Fee",
    "priceList.accessoryPrice": "Accessory Price",
    "priceList.profitTax": "Profit & Tax",
    "priceList.profitTaxHint": "Decimal, e.g. 0.13 = 13%",
    "priceList.priceComposition": "Price Composition",
    "priceList.priceHistory": "Price History",
    "priceList.formula": "Factory Cost = (Price/Meter × Material Usage + Processing Fee + Accessory Price) × (1 + Profit & Tax)",
    "priceList.computedCost": "Computed Factory Cost",
    "priceList.applyComputed": "Apply to Factory Cost",
    "priceList.noHistory": "No price history yet.",
    "priceList.changedBy": "Changed By",
    "priceList.saveRowFirst": "Save the product first to use this feature",
    "ai.dropzone": "Click or drop the factory quote photo here",
    "ai.dropzoneHint": "Chinese text will be auto-extracted & translated to English",
    "ai.scanning": "AI scanning & translating...",
    "ai.success": "Extracted and filled fields from photo",
    "ai.error": "AI extraction failed",
    "users.title": "Users",
    "users.addEmployee": "Add User",
    "users.name": "Name",
    "users.email": "Email",
    "users.password": "Password",
    "users.passwordNew": "New password",
    "users.passwordHint": "Leave blank to keep current; min 8 chars with a letter and a digit",
    "users.passwordLeaveBlank": "Leave blank to keep current password",
    "users.passwordRule": "Password must be at least 8 characters and contain both letters and digits",
    "users.role": "Role",
    "users.language": "Language",
    "users.currency": "Currency",
    "users.priceMultiplier": "Price Multiplier",
    "users.admin": "Admin",
    "users.employee": "Employee",
    "users.editUser": "Edit User",
    "users.sendReset": "Send password reset email",
    "users.devices": "Devices",
    "users.unbindDevices": "Unbind all devices",
    "users.devicesUnbound": "Devices unbound — the user can sign in from new devices",
    "users.role_admin": "Admin",
    "users.role_export": "Export Sales",
    "users.role_gt_export": "GT Export Sales",
    "users.role_buyer": "Buyer",
    "users.role_production_manager": "Product Manager",
    "users.role_sales_manager": "Sales Manager",
    "users.role_procurement_manager": "Procurement Manager",
    "users.role_market_surveyor": "Market Surveyor",
    "users.role_product_manager": "Product Manager",
    "users.role_user_admin": "User Admin",
    "users.role_factory": "Factory",
    "users.role_customer": "Customer",
    "users.manager": "Manager (上级)",
    "users.managerNone": "— None —",
    "apiTokens.title": "API Tokens",
    "apiTokens.subtitle": "Long-lived bearer tokens for external integrations. Never expire; revoke anytime.",
    "apiTokens.create": "New Token",
    "apiTokens.name": "Name",
    "apiTokens.namePlaceholder": "e.g. ERP sync, FileMaker bridge",
    "apiTokens.prefix": "Prefix",
    "apiTokens.scope": "Scope",
    "apiTokens.scope_fullaccess": "Full access",
    "apiTokens.scope_fullaccess_hint": "Read + write, same as admin",
    "apiTokens.scope_readonly": "Read only",
    "apiTokens.scope_readonly_hint": "GET requests only, cannot modify data",
    "apiTokens.createdBy": "Created by",
    "apiTokens.createdAt": "Created",
    "apiTokens.lastUsed": "Last used",
    "apiTokens.status": "Status",
    "apiTokens.active": "Active",
    "apiTokens.revoked": "Revoked",
    "apiTokens.revoke": "Revoke",
    "apiTokens.revokeConfirm": "Revoke token '{name}'? External systems using it will stop working immediately.",
    "apiTokens.empty": "No API tokens yet. Create one to let external systems call the API.",
    "apiTokens.token": "Token",
    "apiTokens.revealTitle": "Save this token now",
    "apiTokens.revealWarning": "This is the only time the full token is shown. Copy and store it in a safe place — you won't be able to see it again.",
    "apiTokens.usageHint": "Use in header:",
    "apiTokens.logs": "API Logs",
    "apiTokens.logsSubtitle": "Every request authenticated via API token, newest first.",
    "apiTokens.logs_time": "Time",
    "apiTokens.logs_token": "Token",
    "apiTokens.logs_method": "Method",
    "apiTokens.logs_path": "Path",
    "apiTokens.logs_status": "Status",
    "apiTokens.logs_duration": "Duration",
    "apiTokens.logs_ip": "IP",
    "apiTokens.logsEmpty": "No API calls logged yet.",
    "apiTokens.logsRetention": "Logs are automatically purged after 30 days.",
    "apiTokens.filterAllTokens": "All tokens",
    "common.refresh": "Refresh",
    "common.done": "Done",
    "common.reset": "Reset",
    "login.forgotPassword": "Forgot password?",
    "reset.title": "Reset Password",
    "reset.forgotTitle": "Forgot Password",
    "reset.forgotHint": "Enter your account email and we'll send you a reset link (valid 30 minutes).",
    "reset.sendLink": "Send Reset Link",
    "reset.emailSent": "Reset email sent",
    "reset.newName": "New Username (optional)",
    "reset.namePlaceholder": "Leave empty to keep current",
    "reset.newPassword": "New Password",
    "reset.confirmPassword": "Confirm Password",
    "reset.submit": "Reset",
    "reset.success": "Password updated. Redirecting to login...",
    "reset.tooShort": "Password must be at least 6 characters",
    "reset.mismatch": "Passwords do not match",
    "reset.backToLogin": "Back to login",
  },
  zh: {
    "app.title": "产品资料库",
    "app.caption": "Product Data Library",
    "products.recordsFound": "条记录",
    "nav.products": "产品",
    "nav.quotes": "报价单",
    "nav.customers": "客户",
    "nav.factories": "工厂",
    "nav.procurementQuotes": "采购报价",
    "nav.productOverview": "产品一览表",
    "po.title": "产品一览表",
    "po.records": "条记录",
    "po.loading": "加载中…",
    "po.empty": "没有找到记录",
    "po.searchHint": "搜索产品编号 / 描述 / 采购员",
    "po.all": "全部",
    "po.category": "分类",
    "po.buyer": "采购",
    "po.photo_type": "图片类型",
    "po.clear": "清空",
    "po.prev": "上一页",
    "po.next": "下一页",
    "po.syncTitle": "产品一览表同步 (FileMaker)",
    "po.syncHint": "从 FileMaker 「产品一览表 · product_photo」 拉取产品图片和元数据；图片会自动下载并托管到 R2，浏览无需 FM 凭证。",
    "po.sync": "开始同步",
    "po.syncing": "同步中",
    "po.syncStarted": "同步已启动",
    "po.createdAt": "建立时间",
    "po.dateRange": "日期",
    "sample.pickProducts": "选择产品",
    "sample.pickSearchPlaceholder": "搜索产品编号 / 描述 / 采购员…",
    "sample.pickedCount": "已选 {n} 个",
    "sample.addSelected": "加入清单",
    "sample.addedToast": "已加入 {n} 个产品（跳过重复 {s} 个）",
    "sample.uploadPhoto": "上传产品照片",
    "sample.uploadedToast": "已上传 {n} 张照片",
    "po.dateRangeHint": "当前数据的日期范围：{from} ~ {to}",
    "po.autoSyncDaily": "每天 {time}（美东）自动同步（仅文字，图片后台补）",
    "po.autoSyncLast": "上次自动同步 {at}，更新 {n} 条",
    "po.autoSyncNever": "尚未执行过自动同步",
    "po.autoAiProgress": "正在处理 {kind} {done}/{total}",
    "po.autoAiLast": "上次运行 {time} · 新增 {d} 条描述 · {c} 张抠图{skip}",
    "po.autoAiTitle": "后台空闲自动处理",
    "po.autoAiCutout": "抠图",
    "po.autoAiHint": "每 10 分钟自动处理一小批；同步进行中或磁盘不足时自动跳过。",
    "po.autoAiDesc": "自动生成描述",
    "po.autoAiRunNow": "立即处理一批",
    "po.autoAiStarted": "已开始处理一批，稍后自动刷新",
    "po.autoAiBusy": "正在处理中，请稍候",
    "po.autoAiPending": "待处理：{d} 条缺描述 · {c} 张待抠图（App 上传） · 每批 {b} 条",
    "po.syncFailed": "同步失败",
    "po.syncStop": "停止同步",
    "po.syncStopping": "正在停止…",
    "po.syncStopRequested": "已请求停止，等待当前批次结束…",
    "po.syncStopFailed": "停止失败",
    "po.syncStopped": "已停止",
    "po.syncDone": "同步完成：已更新 {n} 条记录，下载 {p} 张图片",
    "po.syncIdle": "尚未同步",
    "po.photos": "张图片",
    "po.loadFailed": "加载失败",
    "po.import.button": "导入产品图片",
    "po.import.title": "导入产品图片",
    "po.import.hint": "文件名将作为产品编号，可在下方逐个修改。",
    "po.import.aiDescribe": "自动 AI 生成产品描述（会略微延长导入时间）",
    "po.import.takePhoto": "拍照",
    "po.import.fromGallery": "从相册选择",
    "po.import.dropHint": "拖入图片或点击选择",
    "po.import.maxHint": "最多 100 张",
    "po.import.filesUnit": "张",
    "po.import.clearAll": "全部清空",
    "po.import.submit": "开始导入",
    "po.import.uploading": "导入中…",
    "po.import.pickFirst": "请先选择图片",
    "po.import.done": "导入完成",
    "po.import.failed": "导入失败",
    "po.import.partialFail": "个文件导入失败",
    "po.import.tooMany": "单次最多",
    "po.import.unsupportedSkipped": "个不支持的文件已跳过",
    "po.detail.itemNumber": "产品编号",
    "po.detail.photoType": "采购图片类型",
    "po.detail.description": "产品描述",
    "po.detail.noDescription": "暂无描述",
    "po.detail.removeBg": "AI 抠图 (去背景)",
    "po.detail.processing": "AI 处理中…",
    "po.detail.bgRemoved": "背景已去除",
    "po.detail.bgFailed": "AI 抠图失败",
    "po.detail.bgRemovedTag": "已抠图",
    "po.detail.restore": "恢复原图",
    "po.detail.restored": "已恢复原图",
    "po.detail.restoring": "恢复中…",
    "po.detail.genDesc": "AI 生成描述",
    "po.detail.descLoading": "AI 生成描述中…",
    "po.detail.descGenerated": "描述已生成",
    "po.detail.edit": "编辑",
    "po.detail.save": "保存",
    "po.detail.saved": "已保存",
    "po.detail.saving": "保存中…",
    "po.detail.actionFailed": "操作失败",
    "common.cancel": "取消",
    "po.detail.webappOrigin": "WebApp 上传",
    "po.date": "日期",
    "common.close": "关闭",
    "common.done": "完成",
    "nav.tags": "标签管理",
    "nav.marketSurvey": "市场产品调查",
    "market.title": "市场产品调查",
    "market.newSurvey": "新建调查",
    "market.emptyList": "暂无调查记录，点右上角「新建调查」",
    "market.selectingFor": "正在为市场产品调查选择产品:",
    "market.backToList": "返回调查列表",
    "market.surveyList": "调查列表",
    "market.productList": "产品清单",
    "market.fmSync": "同步 FileMaker",
    "market.fmSyncing": "同步中",
    "market.stop": "停止",
    "market.stopSent": "停止指令已发送",
    "market.myFavorites": "我的收藏",
    "api.panelTitle": "外部 App 接入（只读 API）",
    "api.panelHint": "下面是外部 App 连接本系统所需的全部参数。先在本页创建一个 readonly 令牌，再把参数填进你的 App。",
    "api.copied": "已复制",
    "api.endpointList": "可用接口清单",
    "api.noteReadonly": "readonly 令牌只允许 GET 读取，任何写操作返回 403。",
    "api.noteRole": "令牌继承创建者的角色权限 —— 用管理员账号创建才能读到全部数据。",
    "api.noteSecret": "令牌请放在你 App 的服务端环境变量里，不要写进前端代码或提交到仓库。",
    "market.favAll": "全部收藏",
    "market.favUngrouped": "未分组",
    "market.favNewGroup": "新建分组",
    "market.favGroups": "收藏分组",
    "market.favNoGroups": "还没有分组，先在收藏栏里新建一个。",
    "market.filterStore": "门店",
    "market.filterStoreAll": "全部门店",
    "market.filterDateFrom": "起始日期",
    "market.filterDateTo": "终止日期",
    "market.filterCategory": "品类",
    "market.filterCategoryAll": "全部品类",
    "market.filterProject": "项目",
    "market.filterProjectAll": "全部项目",
    "market.filterPurpose": "图片类型",
    "market.filterPurposeAll": "全部类型",
    "market.searchName": "搜索产品名称",
    "market.reset": "重置",
    "market.selected": "已选",
    "market.clearSelection": "清空选择",
    "market.selectAll": "全选（{n}）",
    "market.unselectAll": "取消全选",
    "market.shareLink": "生成链接",
    "market.shareSetupTitle": "生成公开链接",
    "market.shareSetupHint": "已选 {n} 个产品将展示在公开图片墙上（30 天有效，对方无需登录）。",
    "market.shareTitleLabel": "链接标题（可不填）",
    "market.shareTitlePlaceholder": "例如：Walmart 秋季调研",
    "market.shareCreate": "生成链接",
    "market.shareDialogTitle": "公开链接已生成",
    "market.shareDialogHint": "共 {n} 个产品 · 任何人打开此链接即可浏览图片墙，无需登录。有效期至 {date}。",
    "market.shareCopy": "复制",
    "market.shareCopied": "链接已复制",
    "market.shareOpen": "打开链接",
    "market.selectionTtl": "保留 24 小时",
    "market.batchPdf": "生成缩略图 PDF",
    "market.batchImport": "导入产品资料库",
    "market.batchPdfGenerating": "生成中…",
    "market.batchImportDone": "导入完成 · 新增 {created} · 跳过 {skipped}",
    "market.loadMore": "加载更多",
    "market.showing": "显示 {shown} / {total}",
    "market.emptyProducts": "暂无产品记录，请先「新建调查」并上传图片",
    "market.noImage": "无图",
    "market.photoCount": "张图",
    "market.productCount": "个产品",
    "market.emptySurveyProducts": "此调查下暂无产品，点「导入图片」上传",
    "market.importPhotos": "导入图片",
    "market.editTitle": "编辑产品资料",
    "market.editProductId": "产品编号 (Product ID)",
    "market.editDescription": "描述",
    "market.editCategory": "品类",
    "market.editCategoryPlaceholder": "选择品类",
    "market.editCategoryNone": "— 不设置 —",
    "market.editProject": "项目",
    "market.editProjectPlaceholder": "选择项目",
    "market.editProjectNewPlaceholder": "输入项目名称",
    "market.editProjectNone": "— 不设置 —",
    "market.editProjectNew": "新增项目…",
    "market.editCountryOfOrigin": "原产地",
    "market.editSupplier": "供应商",
    "market.editNotes": "备注",
    "market.editPhotoTotal": "此产品共",
    "market.zoom": "查看大图",
    "market.saved": "已保存",
    "market.delete": "删除",
    "market.deleteConfirm": "确认删除该产品记录？此操作不可撤销。",
    "market.deleted": "已删除",
    "market.cancel": "取消",
    "market.save": "保存",
    "market.uploadTitle": "上传市场产品调查图片",
    "market.uploadClickToPick": "点击选择文件",
    "market.uploadHint": "JPG · PNG · HEIC · WebP · ≤ 300 张 · 自动压至 3MB",
    "market.uploadPicked": "已选",
    "market.uploadSucceeded": "成功",
    "market.uploadFailed": "失败",
    "market.uploadClear": "清空",
    "market.uploadRetryFailed": "重试失败",
    "market.uploadPreset": "预设信息（将应用于所有上传的图片）",
    "market.uploadStore": "商店",
    "market.uploadDate": "日期",
    "market.uploadPurposeSelect": "选择图片用途",
    "market.uploadProjectSelect": "选择项目",
    "market.uploadCategorySelect": "选择品类",
    "market.uploadPurposeCustom": "+ 新增图片用途…",
    "market.uploadProjectCustom": "+ 新增项目…",
    "market.uploadPurposeNew": "新用途名称",
    "market.uploadProjectNew": "新项目名称",
    "market.uploadClose": "关闭",
    "market.uploadStart": "开始上传",
    "market.uploadTooMany": "单次最多 300 张",
    "market.uploadPurposeRequired": "请选择图片用途",
    "market.uploadDone": "上传完成",
    "market.newSurveyTitle": "新建市场调查",
    "market.newSurveyStore": "商店",
    "market.newSurveyStorePlaceholder": "选择或输入商店",
    "market.newSurveyDate": "日期",
    "market.newSurveySurveyor": "调查人",
    "market.newSurveyNotes": "备注",
    "market.newSurveyCreate": "创建",
    "market.newSurveyCreated": "调查已创建",
    "market.syncStarted": "FileMaker 同步已启动，稍后自动刷新",
    "market.syncDoneToast": "同步完成 · 新增 {created} · 已有 {existing} · 错误 {errors}",
    "market.syncFailed": "同步失败",
    "tags.title": "标签管理",
    "tags.allTags": "所有标签",
    "tags.hideSidebar": "隐藏标签栏",
    "tags.showSidebar": "显示标签栏",
    "tags.allProducts": "全部产品",
    "tags.addNew": "增加 Tag",
    "tags.newTagPlaceholder": "新标签名称",
    "tags.onlyMineHint": "仅显示你建立或共享给你的标签（最新 10 个）",
    "tags.createdOk": "标签已创建",
    "tags.createFailed": "标签创建失败",
    "tags.share": "共享",
    "tags.shareTitle": "共享标签",
    "tags.shareHint": "选中的用户可以看到并使用此标签",
    "tags.shareSaved": "共享设置已更新",
    "tags.shareFailed": "共享设置更新失败",
    "tags.noUsers": "暂无可选用户",
    "tags.sharedToMe": "共享给我",
    "co.attachTitle": "订单产品资料",
    "co.importBtn": "导入订单产品资料",
    "co.dialogTitle": "导入订单产品资料",
    "co.noPhoto": "无产品图片",
    "co.dialogSubtitle": "从订单产品资料中搜寻并导入装箱信息",
    "co.searchLabel": "搜索中文名称 / 英文名称 / 产品编号 / 合同号 / 厂家",
    "co.searchPlaceholder": "请输入关键词",
    "co.contractNo": "合同号",
    "co.customer": "客户",
    "co.factory": "厂家",
    "co.contractDate": "合同日期",
    "co.all": "全部",
    "co.search": "搜索",
    "co.reset": "重置",
    "co.refresh": "刷新",
    "co.recordCount": "共 {n} 条记录",
    "co.colName": "产品名称",
    "co.colItem": "产品编号",
    "co.colContract": "合同号",
    "co.colPacking": "装箱信息",
    "co.colPurchasePrice": "采购价",
    "co.gtPrice": "GT Price",
    "co.exportPrice": "外销价",
    "co.lowestLabel": "历史最低价",
    "co.lowestOf": "{n} 笔含价合同中最低",
    "co.lowestBadge": "最低",
    "co.colQty": "数量",
    "co.vsCurrent": "当前成本",
    "co.alsoImportPrice": "同时把采购价导入工厂成本",
    "co.colActions": "操作",
    "co.preview": "预览",
    "co.import": "导入",
    "co.selectedTitle": "选中产品装箱资料",
    "co.selectHint": "点击左侧记录预览其装箱资料",
    "co.packingWillImport": "装箱信息（将被导入）",
    "co.packingRate": "装箱率",
    "co.length": "长",
    "co.width": "宽",
    "co.height": "高",
    "co.grossWeight": "毛重",
    "co.overwriteHint": "确认导入后，将覆盖当前装箱数据。",
    "co.confirmImport": "确认导入",
    "co.imported": "装箱数据已导入",
    "co.empty": "没有匹配的订单产品资料",
    "co.noMatch": "没有找到该产品编号的历史合同记录",
    "co.matchedBy": "匹配",
    "co.perPage": "条/页",
    "co.syncTitle": "合同订单产品同步",
    "co.syncHint": "单向从 FileMaker 合同订单库拉取，每天美东时间早上 07:00 自动同步，也可在此手动触发。",
    "co.sinceLabel": "同步起始日期 (MM/DD/YYYY)",
    "co.syncing": "同步中",
    "co.syncNow": "立即同步",
    "co.syncCount": "已存储 {n} 条订单产品记录",

    "tags.myProducts": "我的产品",
    "tags.myProductsHint": "只显示外销或采购是我的产品",
    "tags.myProductsFallback": "没有属于你的产品，已显示全部产品",
    "tags.searchTag": "搜索标签",
    "tags.searchProduct": "搜索产品 (SKU / 货号 / 描述)",
    "tags.label": "标签",
    "tags.productsShown": "个产品",
    "tags.empty": "此标签下暂无产品",
    "tags.newTitle": "新增标签",
    "tags.editTitle": "编辑标签",
    "tags.name": "标签名",
    "tags.color": "颜色",
    "tags.saved": "已保存",
    "tags.deleted": "已删除",
    "tags.deleteTitle": "删除标签",
    "tags.deleteConfirm": "确定删除标签",
    "tags.deleteNote": "标签会被隐藏，已打此标签的产品数据保留。",
    "tags.rename": "重命名",
    "tags.changeColor": "改颜色",
    "tags.delete": "删除",
    "tags.emptyName": "标签名不能为空",
    "tags.addTag": "添加",
    "tags.noMatch": "无匹配标签",
    "tags.allSelected": "已选完全部",
    "tags.batchAddTag": "批量加标签",
    "tags.addToQuote": "加入报价单",
    "tags.batchRemoveTag": "从此标签移除",
    "tags.batchAddTitle": "批量为选中产品加标签",
    "tags.batchAdded": "已添加标签",
    "tags.batchRemoved": "已移除标签",
    "tags.selectedCount": "已选",
    "tags.emptyDict": "尚未创建任何标签",
    "common.clear": "取消选中",
    "nav.help": "帮助",
    "pq.title": "采购报价",
    "pq.records": "条记录",
    "pq.searchPlaceholder": "搜索产品编号 / 名称 / 工厂 / 报价客户 — 输入完按回车",
    "pq.searchButton": "搜寻",
    "pq.resetColumns": "重置列宽",
    "pq.columns": "显示列",
    "pq.columnsShowAll": "全部显示",
    "pq.resizeHint": "拖动调整列宽",
    "pq.dateFrom": "开始日期",
    "pq.dateTo": "结束日期",
    "pq.allBuyers": "全部外销",
    "pq.allCustomers": "全部客户",
    "pq.delete": "删除",
    "pq.deleteConfirm": "确认删除这条报价？此操作不可撤销。",
    "pq.deleted": "已删除",
    "pq.deleteDisabledHint": "仅可删除自己当天创建的报价",
    "pq.presetToday": "今日",
    "pq.presetWeek": "本周",
    "pq.clearFilters": "清除筛选",
    "pq.priceMin": "最低价",
    "pq.priceMax": "最高价",
    "pq.newButton": "新建报价",
    "pq.newTitle": "新建采购报价",
    "pq.optionalFields": "可选字段",
    "pq.sourceHint": "APP 保存后立即推送 FileMaker；失败保留待同步数据。毛重、标签等本地字段仅保存在 APP。",
    "pq.savedApp": "已保存到 APP",
    "pq.draftRetained": "尚未保存，草稿已保留，请重试",
    "pq.syncDetails": "同步状态与记录",
    "pq.retrySync": "重试同步",
    "pq.retryQueued": "已安排重试同步",
    "pq.syncState.pending": "已存 APP · 等待同步 FM",
    "pq.syncState.pushing": "已存 APP · 正在同步",
    "pq.syncState.retry": "已存 APP · 等待重试",
    "pq.syncState.synced": "已同步至 FileMaker",
    "pq.syncState.conflict": "字段冲突 · APP 修改已保留",
    "pq.syncState.missing": "FM 记录已删除 · APP 已保留",
    "pq.syncState.uncertain": "新建结果未确认 · 待核对",
    "pq.syncState.review": "旧版待同步修改 · 待核对",
    "pq.syncState.pending_delete": "等待同步删除",
    "pq.syncState.deleted": "已删除",
    "pq.syncCounts": "待同步：{p} 条 · 需要核对：{a} 条",
    "pq.createdOk": "新建成功",
    "pq.required": "必填",
    "pq.pickFromProducts": "从产品资料拉入",
    "pq.pickHint": "从已有产品一键填入产品编号、名称、尺寸",
    "pq.pickSearchPlaceholder": "搜索产品编号或名称...",
    "pq.pickEmpty": "没有匹配的产品",
    "pq.pickFilled": "已从产品填入",
    "pq.editTitle": "编辑采购报价",
    "pq.autoSaveHint": "修改后自动保存",
    "pq.autoSaving": "正在保存…",
    "pq.autoSaved": "已自动保存",
    "pq.updatedOk": "报价已更新",
    "pq.edit": "编辑",
    "pq.editDisabledHint": "只能编辑业务员是自己的 WebApp 记录（FM 同步记录只读）",
    "pq.duplicate": "复制到今日",
    "pq.duplicatedOk": "已复制到今日报价",
    "pq.saveAsCopy": "复制为新记录",
    "pq.copiedOk": "已复制为新记录",
    "pq.newRecordBadge": "新记录",
    "pq.tag": "标签",
    "pq.resizeHint": "拖动调整列宽 · 双击自动适应",
    "pq.columnWidths": "调整列宽",
    "pq.columnWidthsDesc": "为每列输入精确的像素宽度，或恢复默认。设置会自动保存，仅对当前用户生效。",
    "pq.columnWidthsHideHint": "提示：把某列宽度设为 0 即可隐藏该列。",
    "pq.columnWidthsResetAll": "全部重置",
    "pq.tagAction": "设置标签",
    "pq.tagPrompt": "输入标签（留空则清除）：",
    "pq.tagSaved": "标签已保存",
    "pq.editMode": "内联编辑",
    "pq.editModeOn": "内联编辑已开启 — 直接点击你的行中的单元格编辑，失焦自动保存。",
    "pq.editModeOff": "已关闭内联编辑",
    "pq.autoSaved": "已自动保存",
    "pq.autoSaveFailed": "自动保存失败",
    "pq.invalidNumber": "无效数字",
    "pq.history": "历史记录",
    "pq.historyModalTitle": "修改历史 — {item}",
    "pq.historyKind": "类型",
    "pq.historyKindCurrent": "当前",
    "pq.historyKindHistory": "历史",
    "pq.historyChangedAt": "修改时间",
    "pq.historyChangedBy": "修改人",
    "pq.historyAction": "操作",
    "pq.historyActionUpdate": "编辑",
    "pq.historyActionTag": "改标签",
    "pq.historyActionDelete": "删除",
    "pq.historyEmptyList": "该产品还没有修改历史记录。",
    "pq.historyButton": "采购报价记录",
    "pq.historyTitle": "采购报价记录",
    "pq.historyEmpty": "没有与该产品采购产品编号匹配的采购报价记录。",
    "pq.copyColHeader": "复制",
    "pq.copyRow": "复制这条记录",
    "pq.copied": "已复制 — 编辑单元格后点击其它位置自动保存",
    "pq.copyFailed": "复制失败",
    "pq.saveFailed": "保存失败",
    "pq.filter": "筛选",
    "pq.minPrice": "最低价",
    "pq.maxPrice": "最高价",
    "pq.dateFrom": "起始日期",
    "pq.dateTo": "终止日期",
    "pq.importSelected": "导入到报价列表",
    "pq.imported": "已导入 {n} 条到产品报价列表",
    "pq.sync": "同步 FileMaker",
    "pq.otherDetails": "其他明细",
    "pq.otherDetailName": "名称",
    "pq.otherDetailAmount": "金额",
    "pq.otherDetailAdd": "增加一行",
    "pq.otherDetailsEmpty": "还没有明细 — 点「增加一行」开始填写",
    "pq.otherDetailFmLocked": "此行由 FileMaker 同步，仅 FM 侧可改",
    "pq.otherDetailFmNote": "带锁的行来自 FileMaker (其他 / 其他1 / 其他2 / 其他3)，仅 FM 侧可改",
    "pq.otherDetailsTotal": "合计（自动写入「其他」）",
    "pq.othersLockedHint": "由明细合计",
    "pq.backfillQtyHq": "补算空缺 QTY/HQ",
    "pq.backfillQtyHqDone": "已补算 {n} 条记录的 QTY/HQ",
    "pq.syncTitle": "采购报价双向同步 (FileMaker)",
    "pq.syncHint": "按字段同步并校验版本。预览环境拉取当月；正式环境按下方起始日期至今天拉取。待同步修改与冲突数据不会被静默覆盖。",
    "pq.syncing": "同步中",
    "pq.syncDone": "同步完成：已更新 {n} 条记录",
    "pq.syncPushSummary": "· 推送：新增 {c} 条，更新 {u} 条，删除 {d} 条",
    "pq.empty": "暂无采购报价数据，点击同步按钮从 FileMaker 导入。",
    "pq.pageInfo": "第 {page} / {pages} 页",
    "pq.prev": "上一页",
    "pq.next": "下一页",
    "pq.date": "日期",
    "pq.quoteCustomer": "报价客户",
    "pq.productPhoto": "产品图片",
    "pq.quoteDate": "报价日期",
    "pq.itemNumber": "产品编号",
    "pq.nameCn": "中文名称",
    "pq.size": "尺寸",
    "pq.thickness": "产品规格",
    "pq.factory": "工厂名称",
    "pq.price": "价格",
    "pq.sectionBasic": "基本信息",
    "pq.sectionPrice": "价格信息",
    "pq.sectionCarton": "装箱数据",
    "pq.priceFormulaHint": "价格 =（每米价 × 用料尺寸 + 各项费用 + 其他 + 其他1 + 其他2 + 其他3）×（1 + 利润税率）",
    "pq.pricePerMeter": "每米价格",
    "pq.materialSize": "用料尺寸",
    "pq.processingFee": "加工费",
    "pq.brandPaper": "商标纸",
    "pq.plasticBag": "塑料袋",
    "pq.linerBoard": "衬板",
    "pq.cartonFreight": "纸箱运费",
    "pq.profitTax": "利税",
    "pq.others": "其他",
    "pq.others123": "其他1/2/3",
    "pq.packingRate": "装箱率",
    "pq.length": "长",
    "pq.width": "宽",
    "pq.height": "高",
    "pq.qtyHq": "QTY HQ",
    "pq.grossWeight": "毛重",
    "upcSync.title": "UPC 码库（FileMaker UPC_API）",
    "upcSync.hint": "每天 06:30 单向从 FileMaker 拉取全部 UPC 码，保证报价编辑器里的「UPC 查询」是最新的。如果你刚在 FileMaker 里直接加了码，可手动同步一次。",
    "upcSync.sync": "立即同步",
    "upcSync.running": "同步中",
    "upcSync.started": "UPC 同步已开始",
    "upcSync.stored": "已存码数：",
    "upcSync.lastRun": "上次同步",
    "sample.manage": "寄样管理",
    "sample.pageHint": "寄样清单全员共享，可按清单名称、客户名称或创建日期查找。",
    "sample.newList": "新建清单",
    "sample.create": "创建",
    "sample.search": "搜索",
    "sample.searchPlaceholder": "清单名称 / 客户名称 / 底单号 / 创建人",
    "sample.customer": "客户名称",
    "sample.customerAny": "全部客户",
    "sample.customerPlaceholder": "选择或输入客户名称",
    "sample.receiptNo": "底单号",
    "sample.receiptNoPlaceholder": "请输入底单号",
    "sample.createdRange": "创建日期",
    "sample.clear": "清空",
    "sample.listName": "清单名称",
    "sample.qtyProducts": "产品数",
    "sample.createdAt": "创建日期",

    "sample.selected": "已选 {n} 个",
    "sample.addTitle": "把 {n} 个产品加入寄样清单",
    "sample.newName": "输入寄样清单名称",
    "sample.namePlaceholder": "例如：GT 九月寄样",
    "sample.createAndAdd": "新建并加入",
    "sample.orExisting": "或加入已有清单",
    "sample.added": "已加入 {n} 个，{s} 个已在清单中",
    "sample.nameRequired": "请输入寄样清单名称",
    "sample.listsTitle": "寄样清单",
    "sample.noLists": "还没有寄样清单 —— 在下方勾选产品后用 Action → 寄样管理 创建。",
    "sample.noItems": "该清单还没有产品",
    "sample.count": "{n} 个产品",
    "sample.createdBy": "创建人",
    "sample.rename": "重命名",
    "sample.renamePrompt": "输入新的寄样清单名称：",
    "sample.delete": "删除清单",
    "sample.deleteConfirm": "删除寄样清单「{name}」及其中所有产品？",
    "sample.deleted": "寄样清单已删除",
    "sample.export": "导出 Excel",
    "sample.itemNo": "产品编号",
    "sample.name": "产品名称",
    "sample.qty": "数量",
    "sample.remark": "备注",
    "sample.remarkPlaceholder": "备注（自动保存）",
    "upc.button": "UPC 查询",
    "upc.title": "UPC 查询 · 来自 FileMaker",
    "upc.importInto": "导入到尺寸行",
    "upc.noRows": "还没有尺寸行",
    "upc.unnamedSize": "（未填尺寸）",
    "upc.search": "搜索",
    "upc.searchPlaceholder": "产品编号 / 描述 / UPC",
    "upc.itemNo": "产品编号",
    "upc.description": "描述",
    "upc.code": "UPC（12 位）",
    "upc.pageTitle": "UPC 查询",
    "upc.clearFilters": "清除筛选",
    "upc.dateCreated": "创建日期",
    "upc.use": "导入",
    "upc.empty": "没有找到匹配的 UPC",
    "upc.imported": "已把 UPC {code} 填入该尺寸行",
    "upc.pickRowFirst": "请先选择要导入的尺寸行",
    "upc.newTitle": "新建 UPC",
    "upc.seq5": "5 位序号",
    "upc.finalPreview": "完整 UPC：",
    "upc.checkDigitHint": "最后一位按 UPC-A 自动计算",
    "upc.createAndImport": "创建并导入",
    "upc.created": "已在 FileMaker 创建 UPC {code}",
    "pq.realtimeHint": "APP 保存后立即推送；平台每 {n} 分钟拉取 FileMaker，并重试待同步记录。",
    "pq.realtimeField": "增量依据字段",
    "pq.realtimeLast": "上次增量",
    "pq.qtyHqAuto": "自动",
    "common.prev": "上一页",
    "common.next": "下一页",
    "pq.salesperson": "业务员",
    "pq.remark": "备注",
    "factories.title": "工厂管理",
    "factories.name": "工厂名称",
    "factories.contactPerson": "联系人",
    "factories.email": "联系邮箱",
    "factories.phone": "联系手机号码",
    "factories.buyer": "负责的采购",
    "factories.noFactories": "暂无工厂",
    "factories.searchPlaceholder": "搜索工厂 / 联系人 / 采购",
    "factories.pickFactoryHint": "请在左侧选择一个工厂，查看它的产品",
    "factories.editDetails": "编辑资料",
    "factories.noProducts": "该工厂暂无关联产品",
    "common.page": "页",
    "factories.newTitle": "新建工厂",
    "factories.editTitle": "编辑工厂",
    "products.factory": "工厂",
    "priceList.qty40": "QTY/40HQ",
    "priceList.usPrice": "US Price",
    "priceList.cadPrice": "Price",
    "customers.title": "客户管理",
    "customers.seller": "外销",
    "customers.newTitle": "新建客户",
    "customers.editTitle": "编辑客户",
    "customers.name": "客户名称",
    "customers.email": "客户联系邮件",
    "customers.contactPerson": "联系人",
    "customers.address": "地址",
    "customers.destinationPort": "目的港",
    "customers.paymentTerms": "付款方式",
    "customers.noCustomers": "暂无客户，点击\"新建\"创建。",
    "nav.settings": "设置",
    "nav.users": "用户管理",
    "nav.logout": "退出登录",
    "nav.hideSidebar": "隐藏菜单栏",
    "nav.showSidebar": "显示菜单栏",
    "nav.userMenu": "用户菜单",
    "nav.changePassword": "修改密码",
    "nav.menu": "菜单",
    "nav.more": "更多",
    "nav.admin": "管理",
    "changePw.hint": "输入当前密码，再设置新密码（至少 6 位）。",
    "changePw.oldPassword": "当前密码",
    "changePw.newPassword": "新密码",
    "changePw.confirmPassword": "确认新密码",
    "changePw.submit": "更新密码",
    "changePw.success": "密码已更新",
    "changePw.tooShort": "新密码至少需要 6 位",
    "changePw.mismatch": "两次输入的新密码不一致",
    "changePw.sameAsOld": "新密码不能与当前密码相同",
    "login.toggleLanguage": "切换语言",
    "login.title": "登录产品资料库",
    "login.subtitle": "报价与价格管理系统",
    "login.email": "邮箱",
    "login.password": "密码",
    "login.submit": "登录",
    "common.save": "保存",
    "common.cancel": "取消",
    "common.back": "上一步",
    "common.close": "关闭",
    "common.delete": "删除",
    "common.remove": "移除",
    "common.edit": "编辑",
    "common.add": "添加",
    "common.search": "搜索货号或描述...",
    "common.loading": "加载中...",
    "common.actions": "操作",
    "common.confirmDelete": "确定要删除吗？此操作无法撤销。",
    "common.all": "全部",
    "common.clearFilters": "清除筛选",
    "products.title": "产品列表",
    "products.justImportedBanner": "显示刚导入的 {n} 条产品",
    "products.clearImportedFilter": "显示全部产品",
    "import.viewImported": "查看导入的产品",
    "products.new": "新建产品",
    "products.editTitle": "编辑产品",
    "products.newTitle": "新建产品",
    "products.itemNumber": "货号",
    "products.description": "产品描述（英文）",
    "products.gtDescription": "GT 产品描述",
    "products.gtDescriptionHint": "简短产品名（最多 30 字符）。用于下载的报价/标签文件名，自动从产品描述读取。",
    "products.descriptionZh": "产品描述（中文）",
    "products.specification": "产品规格（英文）",
    "products.specificationZh": "产品规格（中文）",
    "products.photo": "产品照片",
    "products.tagsLabel": "标签",
    "products.noPhoto": "无图",
    "products.factoryQuotePhoto": "工厂报价单照片",
    "products.uploadPhoto": "上传照片",
    "products.zoomPhoto": "放大查看",
    "products.newBadge": "新品",
    "products.newProducts": "近2周新品",
    "products.newOnly": "只看新品",
    "products.allProducts": "全部产品",
    "products.newOnlyHint": "只显示 {n} 天内建档的新品，以及产品类型为空的产品（天数可在设置里调整）",
    "products.newProductDays": "新品天数",
    "products.newProductDaysHint": "建档日期距今不超过这个天数就算新品（徽章 + 只看新品筛选）",
    "products.appCreationDate": "App 创建日期",
    "products.newProductsHint": "显示近 2 周内创建的产品，按品类排序",
    "products.priceRange": "报价范围",
    "products.noProducts": "暂无产品，请新建第一个产品。",
    "products.photoUpdated": "产品照片已更新",
    "products.category": "类别",
    "products.subcategory": "子类别",
    "products.brand": "品牌",
    "products.buyer": "采购",
    "products.seller": "外销",
    "products.tag": "Tag",
    "quote.exportExcel": "导出 Excel",
    "quote.fullscreen": "产品清单全屏",
    "quote.exitFullscreen": "退出全屏",
    "pq.fullscreen": "全屏",
    "quote.editor.itemNumberSaved": "产品编号已更新（仅本报价单）",
    "quote.editor.originalItemNumber": "原产品编号",
    "plink.action": "生成链接",
    "plink.title": "生成产品分享链接",
    "plink.selected": "已选 {n} 个产品",
    "plink.titleLabel": "链接标题（可选）",
    "plink.titlePlaceholder": "例如 2026 春季新品",
    "plink.validity": "有效期",
    "plink.days": "{n} 天",
    "plink.forever": "永久",
    "plink.generate": "生成链接",
    "plink.shareLink": "分享链接",
    "plink.embedCode": "网页内嵌代码 (iframe)",
    "plink.copied": "已复制",
    "plink.resultMeta": "共 {n} 个产品 · 有效期至 {exp}",
    "plink.rulesHint": "未登录访客只看到产品图片、产品编号与英文描述；注册用户额外看到美金价格（原价 × 该用户的价格系数）。页面内容为全英文。",
    "pq.sinceLabel": "同步起始日期",
    "pq.sinceHint": "格式 MM/DD/YYYY，结束日期自动到今天；只影响手动/全量同步",
    "pq.exitFullscreen": "退出全屏",
    "pq.mobileFilters": "筛选条件",
    "pq.mobileFieldsTitle": "卡片显示字段",
    "pq.takePhoto": "拍照",
    "pq.photoUploaded": "产品图片已更新",
    "pq.loadMore": "加载更多",
    "quote.emailQuote": "邮件发送报价单",
    "quote.emailSending": "发送中...",
    "quote.emailSent": "报价单已发送至",
    "quote.emailError": "邮件发送失败",
    "quote.exportPdf": "导出 PDF",
    "quote.printLabels": "打印 Label",
    "quote.exportError": "导出失败",
    "quote.exportSuccess": "导出已下载",
    "quote.exportCustomerTemplate": "客户报价单导出",
    "quote.customerTemplateNone": "客户 '{name}' 尚未上传报价单模板，请先到客户管理页面上传",
    "quote.customerTemplatePickHint": "客户 '{name}' 有多个模板，请选择使用哪一个进行填充",
    "quote.selectAllRows": "全选 / 取消全选（勾选后仅导出选中的价格行）",
    "quote.colDragHint": "拖动表头可调整列顺序",
    "quote.freightShort": "海运费",
    "quote.pricingParams": "价格计算参数",
    "quote.paramCurrency": "币种",
    "quote.paramFx": "报价汇率 US$→¥",
    "quote.paramCadFx": "美金对加币汇率",
    "quote.paramFreight": "海运费 / 40HQ",
    "quote.paramProfit": "利润率",
    "quote.paramMultiplier": "价格系数",
    "quote.paramPerProductHint": "关税与退税率按每个产品的实时资料读取。",
    "quote.paramFormulaUsd": "计算价 = 人民币工厂成本 ÷ 报价汇率（向上取整到 0.05）",
    "quote.paramFormulaCad": "计算价 = (美元成本 ×(1+关税) + 海运费 ÷ 40HQ装箱量) ÷ (1-利润率) × 美加汇率 × 价格系数",
    "quote.colOrderReset": "恢复默认列顺序",
    "quote.editor.title": "产品详细资料（仅对本报价单）",
    "quote.editor.openHint": "点击可为该报价单单独编辑这个产品的详细资料",
    "quote.editor.noItems": "报价单里还没有产品，请先添加产品再编辑。",
    "quote.editor.loading": "加载中……如长时间未显示，请关闭后重新点击。",
    "quote.editor.rowAdded": "已添加尺寸",
    "quote.editor.rowsImported": "已导入 {n} 条采购报价",
    "quote.editor.rowDeleted": "已删除",
    "quote.editor.deleteRow": "删除此尺寸行",
    "quote.editor.confirmDeleteRow": "确认删除这一尺寸行？",
    "quote.removeItem": "从报价单删除此产品",
    "quote.editor.prev": "上一个",
    "quote.editor.next": "下一个",
    "quote.editor.photo": "产品图片",
    "quote.editor.uploadPhoto": "上传图片",
    "quote.editor.resetPhoto": "恢复为产品原图",
    "quote.editor.similarPhotos": "产品一览表相似图片",
    "quote.editor.photoLibrary": "相似图片（产品清单 / 一览表 / 市场调查）",
    "quote.editor.photoLibraryShort": "相似图片",
    "quote.editor.searchAllPhotos": "搜索产品清单、一览表、市场调查图片",
    "quote.editor.src.product": "清单",
    "quote.editor.src.overview": "一览",
    "quote.editor.src.market": "市场",
    "quote.editor.searchOverviewPhotos": "搜索整个产品一览表（货号 / 描述）",
    "quote.editor.noOverviewPhotos": "无匹配图片",
    "quote.editor.override": "已覆盖",
    "quote.editor.description": "产品描述",
    "quote.editor.gtDescription": "GT产品描述（短版）",
    "quote.editor.gtGenerating": "AI 正在生成…",
    "quote.editor.gtLengthWarning": "GT 描述已 {n} 字符，超过 30 字符建议缩短",
    "quote.editor.specMaterial": "规格 & 材料（Specification & Material）",
    "quote.editor.buyerPlaceholder": "请选择采购…",
    "quote.editor.inquire": "是否询价",
    "quote.editor.buyerQuoted": "采购已报价",
    "quote.editor.procurementNote": "采购报价要求",
    "quote.editor.procurementNotePlaceholder": "需要采购报价的内容（材质、包装、起订量、目标价…）",
    "quote.editor.generateLink": "生成链接",
    "quote.editor.linkNeedsBuyer": "请先选择该产品的采购员",
    "quote.editor.linkTitle": "采购链接已生成",
    "quote.editor.linkHint": "把链接发给 {buyer}，打开后可看到本报价单中分配给他的 {n} 个产品。采购需登录系统。",
    "quote.editor.linkCopy": "复制",
    "quote.editor.linkCopied": "链接已复制",
    "quote.editor.linkExpires": "有效期至 {date}（30 天）",
    "procReq.priceRows": "价格明细栏（可从采购报价导入）",
    "procReq.factoryCost": "工厂成本",
    "procReq.tabPrice": "报价",
    "procReq.tabPacking": "装箱",
    "procReq.moq": "起订量",
    "procReq.qtyPerCtn": "装箱数",
    "procReq.caseSize": "箱规 长×宽×高",
    "procReq.containerQty": "40尺柜装箱量",
    "procReq.noRows": "还没有价格明细 — 打开采购报价记录后导入",
    "procReq.deleteRow": "删除当日导入的记录",
    "procReq.markDone": "完成报价",
    "procReq.moqRequired": "请先填写起订量",
    "procReq.markedDone": "已标记完成报价",
    "procReq.notDoneYet": "尚未完成报价",
    "procReq.imported": "已导入 {n} 条",
    "pq.newRecord": "新增记录",
    "procReq.title": "采购报价要求",
    "procReq.expires": "有效期至 {date}",
    "procReq.empty": "本报价单里没有分配给你的产品",
    "procReq.noNote": "外销未填写报价要求",
    "procReq.fileQuote": "填写采购报价",
    "procReq.submitted": "采购报价已保存",

    "quote.editor.specification": "规格 (Specification)",
    "quote.editor.material": "材料",
    "quote.editor.priceRows": "价格行（每个尺寸）",
    "quote.editor.dragToSort": "拖动排序",
    "quote.editor.noRows": "该产品还没有价格行",
    "quote.editor.saveAndClose": "保存并关闭",
    "quote.editor.autoSaveHint": "切换或关闭时自动保存",
    "quote.editor.snapshotHint": "此处修改仅对本报价单生效，不会影响原产品数据",
    "quote.editor.saveFailed": "保存失败",
    "quote.editor.uploadFailed": "图片上传失败",
    "quote.editor.col.size": "尺寸",
    "quote.editor.col.customer_price": "计算价",
    "quote.editor.writeBack": "写回产品资料",
    "quote.editor.duplicated": "已在本报价单内复制该产品（含价格明细）",
    "quote.editor.writeBackConfirm": "确认把本报价单中该产品的价格信息（成本、箱规、柜量等）连同压缩率、关税写回产品资料库？\n\n不会写回 Final Price；同名尺寸会被更新，新尺寸会新增，产品库中多出的尺寸行保持不动。",
    "quote.editor.writeBackDone": "已写回产品资料 — 更新 {updated} 行，新增 {created} 行",
    "quote.editor.col.upc": "UPC 条码",
    "quote.editor.col.final_price": "Final Price",
    "quote.editor.col.factory_cost": "工厂成本",
    "quote.editor.col.factory_cost_usd": "工厂成本 US$",
    "quote.editor.col.case_length": "箱长 (cm)",
    "quote.editor.col.case_width": "箱宽 (cm)",
    "quote.editor.col.case_height": "箱高 (cm)",
    "quote.editor.col.case_weight": "毛重 (kg)",
    "quote.editor.col.qty_per_ctn": "装箱数",
    "quote.editor.col.container_qty_40": "40尺柜装箱量",
    "quote.editor.col.compression_rate": "压缩率",
    "quote.editor.col.container_qty_40_compressed": "压缩后柜量",
    "products.selectAll": "全选",
    "products.searchPlaceholder": "搜索 货号 / 采购编号 / 描述 / Tag",
    "products.creationDateFilter": "创建日期",
    "products.factoryCostFilter": "工厂成本",
    "products.sellingPriceFilter": "销售价格",
    "products.min": "最低",
    "products.filters": "筛选",
    "products.loadMore": "加载更多",
    "products.max": "最高",
    "products.prevProduct": "上一个",
    "products.nextProduct": "下一个",
    "products.autoSaveHint": "修改会自动保存",
    "dup.title": "查找重复",
    "dup.hint": "货号相同或相近的产品分组如下，勾选要删除的产品。",
    "dup.none": "未发现重复产品",
    "dup.exact": "货号相同",
    "dup.similar": "货号相近",
    "dup.priceRows": "价格行",
    "dup.deleteSelected": "删除所选",
    "dup.confirmTitle": "确认删除这些产品？",
    "dup.deleted": "已删除",
    "products.deselectAll": "取消全选",
    "products.clearSelection": "清空选择",
    "products.actions": "批量操作",
    "products.setTag": "设置 Tag",
    "products.gridPdf": "网格视图 PDF",
    "products.gridPdfTitle": "产品目录",
    "products.perPage": "每页",
    "scanner.title": "扫描货号",
    "scanner.hint": "把条码 / 二维码对准取景框，自动识别后填入搜索。没有条码可点下方「拍照识别」。",
    "scanner.ocrHint": "拍一张印有货号的标签 / 吊牌，AI 自动识别后填入搜索。",
    "scanner.ocrSubhint": "点击按钮打开相机，对准货号拍一张即可。没货号或拍不清，可切换到实时扫码或手输。",
    "scanner.ocrFrameHint": "把货号对准方框内，按下圆钮拍摄。只识别框内文字，速度更快。",
    "scanner.alignHint": "把货号对准方框内，按下方圆钮拍摄",
    "scanner.capture": "拍摄",
    "scanner.recognizing": "识别中…",
    "card.title": "拍照识别名片",
    "card.hint": "把名片放进方框，按下方圆钮拍摄，AI 自动填入客户信息",
    "card.alignHint": "把名片对准方框内，按下方圆钮拍摄",
    "card.recognized": "名片识别成功",
    "card.notRecognized": "没有识别到任何信息，请对准名片重拍",
    "customers.scanCard": "拍名片自动填",
    "customers.saveAndNewQuote": "保存并新建报价",
    "customers.phone": "联系电话",
    "customers.title_label": "职位",
    "customers.website": "公司网址",
    "customers.importance": "客户重要性",
    "customers.importanceAiOnly": "由 AI 根据名片智能评定，不可手动修改",
    "customers.importanceReason": "AI 评级理由",
    "customers.customerType": "客户类型",
    "customers.assessmentReport": "客户综合评估报告",
    "customers.showReport": "查看完整评估报告",
    "customers.hideReport": "收起",
    "customers.filterByImportance": "按重要性筛选",
    "customers.allImportance": "全部评级",
    "customers.sortByImportance": "按重要性排序",
    "customers.notRated": "未评级",
    "customerType.chain": "连锁店",
    "customerType.importer": "进口商",
    "customerType.retailer": "零售商",
    "customerType.wholesaler": "批发商",
    "customerType.agent": "代理商",
    "customerType.unknown": "暂不确定",
    "importance.5": "核心客户",
    "importance.4": "重点客户",
    "importance.3": "潜力客户",
    "importance.2": "普通客户",
    "importance.1": "待观察",
    "scanner.manualHint": "手动输入货号，回车确认。",
    "scanner.starting": "摄像头启动中…",
    "scanner.live": "扫码",
    "scanner.ocr": "拍照识别",
    "scanner.manual": "手输",
    "scanner.manualPlaceholder": "输入货号后回车",
    "scanner.cameraDenied": "无法启动摄像头，请检查浏览器权限或改用拍照 OCR",
    "scanner.permDenied": "请在浏览器设置里允许访问摄像头，然后重试",
    "scanner.noCamera": "未检测到可用摄像头",
    "scanner.cameraBusy": "摄像头被其他程序占用，请关闭后重试",
    "scanner.recognized": "识别到",
    "scanner.notRecognized": "没有识别到货号，请换张清晰的图片或手动输入",
    "scanner.ocrFailed": "OCR 失败",
    "scanner.filled": "已填入搜索框",
    "po.batch.deleteConfirm": "确认删除所选的 {n} 条产品一览记录？该操作不可撤销。",
    "po.batch.needItemNumber": "所选记录没有产品编号，无法执行此操作",
    "po.batch.addToQuoteDone": "已加入报价单",
    "po.batch.failed": "失败",
    "products.customerQuote": "下载客户报价单",
    "products.customerQuoteDesc": "使用客户上传的模板填充 {n} 个已选产品",
    "products.downloadExcel": "下载 Excel",
    "customers.quoteTemplate": "客户报价单模板 (Excel)",
    "customers.quoteTemplateHint": "上传 .xlsx / .xlsm 模板，单元格里写占位符如 {{customer.name}}、{{product.item_number}}、{{row.customer_price}}、{{product.photo}}。支持多个命名模板。",
    "customers.templateUpload": "上传模板",
    "customers.templateUploaded": "模板文件",
    "customers.templateReplace": "替换",
    "customers.templateSaved": "模板已保存",
    "customers.templateXlsxOnly": "只支持 .xlsx 文件",
    "customers.templateReady": "已上传模板",
    "customers.templateMissing": "未上传模板",
    "customers.pickTemplate": "选择报价单模板",
    "customers.noTemplatesAny": "尚无客户上传模板，请先在客户管理页上传。",
    "customers.templateManage": "管理模板",
    "customers.templateAdd": "添加模板",
    "customers.templateAttached": "已添加模板到客户",
    "customers.attachTemplateTitle": "添加报价单模板",
    "customers.attachTemplateHint": "从系统模板库中选择一个模板。模板由管理员统一维护。",
    "customers.noSystemTemplates": "系统模板库暂无模板，请联系管理员先添加。",
    "customers.templateNamePrompt": "为模板命名（例如：GT报价单）：",
    "customers.templateCheck": "检查占位符",
    "templateAnalysis.title": "模板兼容性检查",
    "templateAnalysis.allClean": "模板中所有占位符均已识别，导出时会正确填充。",
    "templateAnalysis.issuesFound": "部分占位符可能无法正确填充，请查看下方详情。",
    "templateAnalysis.known": "已识别",
    "templateAnalysis.typos": "疑似拼写错误",
    "templateAnalysis.unknown": "未知字段",
    "templateAnalysis.photos": "图片占位",
    "templateAnalysis.sheets": "工作表",
    "templateAnalysis.placeholders": "占位符",
    "templateAnalysis.typosHeader": "疑似拼写错误 — 是否想要…？",
    "templateAnalysis.typosHint": "这些占位符看起来是已知字段的拼写错误。请在模板文件中改正。",
    "templateAnalysis.unknownHeader": "未知占位符",
    "templateAnalysis.unknownHint": "这些占位符无法匹配任何已知字段，导出时对应单元格将留空。",
    "templateAnalysis.sheetsHeader": "工作表分析",
    "templateAnalysis.autofix": "一键修复拼写",
    "templateAnalysis.autofixConfirm": "将模板中的 {count} 个疑似拼写错误自动改为建议拼写并保存？",
    "templateAnalysis.autofixSuccess": "已修复 {count} 个占位符",
    "templateAnalysis.autofixFailed": "自动修复失败",
    "templateAnalysis.autofixNothing": "没有可修复的拼写错误",
    "nav.systemTemplates": "系统模板",
    "nav.badImages": "坏图清单",
    "badImg.title": "坏图扫描",
    "badImg.hint": "逐张校验产品照片（主图 / 工厂报价图 / 花型图 / 合成图），列出浏览器打不开的图片：老 FileMaker 的 WMF 容器、文件已不存在、或改了扩展名的非图片文件。后台运行，可随时停止。",
    "badImg.scan": "开始扫描",
    "badImg.scanning": "扫描中",
    "badImg.scanStarted": "扫描已开始",
    "badImg.stop": "停止",
    "badImg.stopRequested": "将在当前记录后停止…",
    "badImg.never": "尚未扫描",
    "badImg.lastRun": "上次扫描",
    "badImg.checked": "已校验图片",
    "badImg.found": "坏图",
    "badImg.listCount": "清单共 {n} 张坏图",
    "badImg.colPreview": "预览",
    "badImg.colField": "图片位置",
    "badImg.colReason": "原因",
    "badImg.fieldPhoto": "产品照片",
    "badImg.fieldFactoryQuote": "工厂报价图",
    "badImg.fieldPattern": "花型照片",
    "badImg.fieldComposite": "合成图片",
    "badImg.reason_unsupported_format": "格式不支持（WMF 等）",
    "badImg.reason_missing_file": "文件已不存在",
    "badImg.reason_undecodable": "文件无法解析为图片",
    "badImg.fix": "从 FileMaker 重新拉取原图",
    "badImg.fixed": "已从 FileMaker 恢复图片",
    "badImg.fixFailed": "无法自动修复",
    "badImg.dismiss": "从清单移除",
    "badImg.empty": "暂无坏图 —— 点「开始扫描」重新检查。",
    "systemTemplates.title": "系统报价模板",
    "systemTemplates.subtitle": "共享报价模板库 — 客户在生成报价单时可选择使用。",
    "systemTemplates.uploadButton": "上传模板",
    "systemTemplates.uploadTitle": "上传新的系统模板",
    "systemTemplates.uploadHint": "仅支持 .xlsx / .xlsm 文件，最大 8 MB。",
    "systemTemplates.nameLabel": "显示名称",
    "systemTemplates.namePlaceholder": "如：GT报价单",
    "systemTemplates.fileLabel": "模板文件",
    "systemTemplates.uploaded": "模板已上传",
    "systemTemplates.uploadFailed": "上传失败",
    "systemTemplates.deleted": "模板已删除",
    "systemTemplates.deleteConfirm": "确定删除模板 \"{name}\" 吗？已经在使用它的客户需要重新选择。",
    "systemTemplates.renamed": "已重命名",
    "systemTemplates.renameTitle": "重命名模板",
    "systemTemplates.empty": "还没有上传任何模板，先添加一个吧。",
    "systemTemplates.analyze": "兼容性检查",
    "systemTemplates.rename": "重命名",
    "systemTemplates.delete": "删除",
    "systemTemplates.download": "下载",
    "systemTemplates.uploadedBy": "上传人",
    "systemTemplates.uploadedAt": "上传时间",
    "customers.empty": "暂无客户",
    "products.tagPrompt": "Tag 将应用到所有选中的产品。留空则清除 Tag。",
    "products.tagApplied": "Tag 已设置",
    "products.copy": "复制产品",
    "products.copied": "已复制",
    "products.sectionIdentity": "基本信息",
    "products.sectionMedia": "产品图片",
    "products.sectionDescription": "描述与规格",
    "products.sectionClassification": "分类与工厂",
    "products.patternPhoto": "花型照片",
    "products.compositePhoto": "合成图片",
    "products.photoEdit": "图片编辑",
    "products.autoSaved": "已自动保存",
    "products.compositeEmpty": "点击生成，把产品图片和花型图片合成一张",
    "products.generateComposite": "生成合成图片",
    "products.compositeGenerated": "合成图片已生成",
    "products.uploadPatternPhoto": "上传花型照片",
    "products.tagList": "标签清单",
    "products.tagListTitle": "标签清单管理",
    "products.tagListDesc": "产品目录中所有 Tag。可批量重命名或删除某个 Tag（跨所有产品）。",
    "products.tagListEmpty": "暂无 Tag。",
    "products.tagListExpand": "展开",
    "products.tagListCollapse": "收起",
    "products.tagListCount": "个产品",
    "products.tagListSearch": "搜索 Tag...",
    "products.tagRename": "重命名",
    "products.tagRenameTitle": "重命名 Tag",
    "products.tagRenameNew": "新的 Tag 名称",
    "products.tagRenamed": "Tag 已重命名",
    "products.tagMergeTitle": "合并 Tag？",
    "products.tagMergeDesc": "Tag「{name}」已存在于 {count} 个产品。合并会将源 Tag 下的所有产品并入目标 Tag。是否继续？",
    "products.tagMerge": "合并",
    "products.tagMerged": "Tag 已合并",
    "products.tagDeleteTitle": "删除 Tag？",
    "products.tagDeleteDesc": "Tag「{name}」被 {count} 个产品使用。删除后会从所有产品中清除该 Tag，产品本身保留。是否继续？",
    "products.tagDeleted": "已从产品中清除 Tag",
    "products.deleteConfirm": "将所选产品移入回收站？30 天内可恢复。",
    "products.deleted": "已删除",
    "products.buyerItemNumber": "采购产品编号",
    "products.fmCreationDate": "FM 创建日期",
    "products.trash": "回收站",
    "products.trashHint": "已删除的产品在此保留 30 天，到期自动永久清除。恢复后产品（含价格表）将回到产品列表。",
    "products.trashEmpty": "回收站是空的",
    "products.daysLeft": "剩余天数",
    "nav.trash": "回收站",
    "products.deletedAt": "删除时间",
    "products.restore": "恢复",
    "products.restored": "已恢复",
    "products.purged": "已永久删除",
    "products.purgeSure": "永久删除？",
    "products.addedToQuote": "个产品已加入",
    "products.material": "材质",
    "products.sellingFeature": "卖点",
    "products.sellingFeatureHint": "产品亮点、独特卖点、营销文案……",
    "products.package": "包装",
    "products.moq": "起订量",
    "quote.editor.moqPlaceholder": "例如 500 sets / 1x40HQ",
    "exportCols.title": "我的导出字段",
    "exportCols.button": "导出字段设置",
    "exportCols.hint": "选择你自己导出报价单 Excel / PDF 时要显示的字段，不影响其他用户。PHOTO 和 ITEM NO 始终包含。",
    "exportCols.save": "保存",
    "exportCols.saved": "导出字段已保存",
    "exportCols.all": "全选",

    "products.removeBg": "一键抠图",
    "products.originalRestored": "已恢复原图",
    "products.restoreOriginal": "恢复原图",
    "products.bgRemoving": "处理中...",
    "products.bgRemoved": "抠图完成，保存生效；不满意可还原。",
    "products.revertBg": "还原图片",
    "products.bgReverted": "已还原",
    "products.taxRebate": "退税率",
    "customers.currency": "货币种类",
    "customers.priceMultiplier": "价格系数",
    "customers.priceMultiplierHint": "对该客户的所有报价单价 × 此系数。默认 1.0（不放大）",
    "customers.profitRate": "利润率",
    "customers.shippingFee": "海运费 (40')",
    "quote.calcPrice": "计算价",
    "quote.currencyFromCustomer": "货币与价格系数来自客户设置 — 导出时基础价 × 系数",
    "settings.quoteExchangeRate": "美金兑人民币汇率",
    "settings.exchangeRateHint": "工厂成本为人民币时用于换算美金",
    "settings.usdToCadRate": "美金兑加币汇率",
    "settings.usdToCadRateHint": "加币客户报价最后乘以此汇率（默认 1.4）",
    "settings.shippingFee": "海运费 (美元 / 40HQ)",
    "settings.shippingFeeHint": "整柜海运费（美元）；计算加币价时按 40HQ 装柜量摊到每件",
    "settings.usdProfitRate": "美金利润率",
    "settings.cadProfitRate": "加币利润率",
    "settings.profitRateHint": "小数，如 0.3 = 30% — 用于产品主页面的参考售价",
    "products.isStandard": "是否标准产品",
    "products.productType": "产品类型",
    "products.stockQuantity": "库存数量",
    "quote.editor.stockPlaceholder": "例：1200 pcs",
    "products.type_stock": "库存产品",
    "products.type_mine": "Low MOQ 产品",
    "products.type_standard": "标准产品",
    "products.type_sample": "样本产品",
    "productTypes.title": "产品类型管理",
    "productTypes.hint": "管理产品类型字典（在筛选和产品表单里显示）。默认类型可以改名或停用，但不能删除。",
    "productTypes.codePlaceholder": "code",
    "productTypes.nameZh": "中文名称",
    "productTypes.nameEn": "English name",
    "productTypes.defaultBadge": "默认",
    "productTypes.on": "启用",
    "productTypes.off": "停用",
    "productTypes.added": "已添加产品类型",
    "productTypes.deleted": "已删除产品类型",
    "productTypes.nameRequired": "中英文名称都必填",
    "productTypes.confirmDelete": "确认删除该产品类型？已标记该类型的产品会显示原始 code，需要手动重新标记。",
    "common.add": "添加",
    "products.showAll": "显示全部",
    "products.showSelected": "显示选择",
    "products.showSelectedEmptyHint": "请先勾选产品",
    "products.viewList": "列表视图",
    "products.viewGrid": "网格视图",
    "products.densityCompact": "紧凑",
    "products.densityComfortable": "舒适",
    "products.favoritesOnly": "我的收藏",
    "products.recentlyViewed": "最近查看",
    "products.mineOnly": "我的产品",
    "products.bulkFavorite": "加入我的收藏",
    "products.addedToFavorites": "已添加到我的收藏",
    "products.removedFromFavorites": "已从我的收藏移除",
    "products.readOnlyNotOwner": "只读：此产品归属其他同事，您可以查看但不能修改。",
    "products.rename": "重命名",
    "products.renameTitle": "重命名 Item Number",
    "products.deleteTitle": "把产品移到回收站",
    "products.deleteWarning": "\"{item}\" 将被移到回收站，30 天后自动永久删除。在此之前可从回收站还原。",
    "products.deletedToTrash": "产品已移到回收站",
    "products.copyProduct": "复制产品",
    "products.addToQuote": "加入报价单",
    "products.pickActiveQuoteFirst": "请先在顶部选择或新建一张活跃报价单",
    "products.copiedTo": "已复制为",
    "products.copyFailed": "复制失败",
    "products.renameWarning": "修改 Item Number 会同步更新它的价格列表和价格历史。已经引用此 Item Number 的历史报价单将保留原编号作为快照，不会随之改动。",
    "products.renameFrom": "当前",
    "products.renameTo": "新 Item Number",
    "products.renameConfirm": "确认重命名",
    "products.renameSuccess": "重命名成功",
    "products.yes": "是",
    "products.no": "否",
    "products.inquiryTime": "询价时间",
    "products.photoUploadTime": "照片上传时间",
    "products.autoTranslate": "自动翻译成中文",
    "products.translating": "翻译中...",
    "products.gridView": "网格视图",
    "products.listView": "列表视图",
    "products.typeOrSelect": "输入或选择...",
    "products.select": "请选择...",
    "products.duty": "关税",
    "products.inquiryDate": "询价日期",
    "products.addToQuote": "加入报价单",
    "products.importExcel": "导入Excel",
    "priceList.loadingRate": "装箱率",
    "priceList.usPrice": "US Price",
    "priceList.cadPrice": "Price",
    "priceList.containerQty": "40尺柜装箱量",
    "priceList.finalPrice": "Final Price",
    "settings.title": "全局设置",
    "settings.currency": "报价币种",
    "settings.subtitle": "用于计算 US Price 和 CAD Price，以上一次保存的值为准。",
    "settings.freight": "运费",
    "settings.rateUr": "汇率UR",
    "settings.rateUc": "汇率UC",
    "settings.profitMargin": "利润率",
    "settings.saved": "设置已保存",
    "settings.formulas": "价格计算公式",
    "settings.options": "选项管理（采购 / 外销 / 类别）",
    "settings.optionsHint": "这些选项会显示在产品表单的下拉框中。回车添加，点 × 删除。产品中已使用的值仍会保留在选项里。",
    "settings.addOption": "添加选项...",
    "settings.subcategoryPickCategory": "所属类别",
    "settings.subcategoryUnassigned": "未分配",
    "settings.usFormula": "US Price 计算公式",
    "settings.cadFormula": "CAD Price 计算公式",
    "settings.fields": "可用字段（点击插入公式）",
    "settings.formulaHint": "支持运算符：+ - * / ( )。点击字段名可插入到当前聚焦的公式中。",
    "settings.preview": "实时预览",
    "settings.sampleRow": "示例数据行",
    "quote.title": "报价单",
    "quote.activeQuote": "当前正在编辑的报价单",
    "quote.new": "新建",
    "quote.deleteRow": "删除此尺寸行",
    "quote.created": "报价单已创建",
    "quote.quoteNumber": "报价单号",
    "quote.copyQuote": "复制报价单",
    "quote.copySharedQuote": "复制这张共享报价单到我自己的列表",
    "quote.buyer": "采购",
    "quote.date": "日期",
    "quote.itemCount": "产品数",
    "quote.customer": "客户",
    "quote.customerName": "客户名称",
    "quote.customerPlaceholder": "选择客户（可选）",
    "quote.customerFromModuleHint": "选项来自客户管理 — 报价按该客户的货币/价格系数/海运费计算",
    "quote.links.button": "采购链接",
    "quote.links.title": "采购链接管理",
    "quote.links.hint": "在产品编辑里按采购员生成的链接，有效期 30 天，可随时作废。",
    "quote.links.empty": "本报价单还没有生成采购链接",
    "quote.links.items": "{n} 个产品",
    "quote.links.submissions": "已填报 {n} 条",
    "quote.links.validUntil": "有效期至 {date}",
    "quote.links.revoke": "作废",
    "quote.links.revoked": "链接已作废",
    "quote.links.revokedTag": "已作废",
    "quote.links.expiredTag": "已过期",
    "quote.procFilled": "采购已填写报价 {n}",
    "quote.procLinkSent": "已发给采购询价",
    "quote.filing.title": "采购填报明细",
    "quote.filing.openHint": "点击查看采购填报的价格与箱规",
    "quote.filing.empty": "采购已标记填报，但本报价单还没有关联的采购报价记录。可打开产品编辑器查看已导入的成本行。",
    "quote.filing.log": "填报记录",
    "quote.filing.hint": "只读展示采购针对本报价单填报的采购报价记录。",
    "quote.procLinkSentHint": "已于 {date} 生成并发送该产品的采购询价链接",
    "quote.procFilledHint": "采购于 {date} 填写了采购报价",
    "quote.exchangeRate": "报价汇率（人民币→美金）",
    "quote.exchangeRateHint": "留空则使用系统设置的汇率（{rate}）。美金价格 = 人民币价格 ÷ 报价汇率。",
    "quote.itemDragToSort": "拖动调整产品顺序",
    "quote.customerNew": "新增客户",
    "quote.customerEdit": "编辑客户",
    "quote.customerFreightUnset": "未设置",
    "quote.customerFreightLabel": "海运费",
    "quote.recomputePrices": "重新计算价格",
    "quote.recomputePricesHint": "按当前汇率/利润率/海运费/客户价格系数重新计算全部价格，并重新锁定",
    "quote.recomputePricesDone": "价格已重新计算并锁定",
    "quote.noQuoteSelected": "请在左侧选择报价单或新建一个。",
    "quote.noBuyer": "未指定采购",
    "quote.editTitle": "编辑报价单",
    "quote.project": "项目",
    "quote.projectPlaceholder": "项目名称（可选）",
    "quote.projectHint": "输入新项目名或从已有项目中选择",
    "quote.shareWithLabel": "共享给",
    "quote.shareQuoteHint": "被选中的员工可以查看该报价单，并可根据所分配的权限进行操作：「只读」仅可查看；「只读和编辑」可查看并编辑。",
    "quote.sharePermissionRead": "只读",
    "quote.sharePermissionEdit": "只读和编辑",
    "quote.projectFilter": "项目",
    "quote.sellerFilter": "外销",
    "quote.allSellers": "全部外销",
    "quote.customerFilter": "客户",
    "quote.scopeMine": "仅我的",
    "quote.scopeAll": "查看全部",
    "quote.allProjects": "全部项目",
    "quote.allCustomers": "全部客户",
    "quote.sharedBadge": "共享",
    "quote.sharedReadOnly": "该报价单为共享 · 只读",
    "quote.sharedEditable": "该报价单为共享 · 您具有编辑权限",
    "quote.shareTitle": "共享项目",
    "quote.shareProject": "共享",
    "quote.shareProjectHint": "共享后，被添加的用户可以查看和导出该项目下所有报价单，但无法编辑。",
    "quote.sharePickProject": "选择项目",
    "quote.shareWithUsers": "共享给用户",
    "quote.shareNoProject": "该报价单还没有项目名称，请先填写项目再共享。",
    "quote.shareNoUsers": "没有可共享的用户。",
    "quote.shareSaved": "共享已更新",
    "quote.shareRevoked": "已取消共享",
    "quote.shareCurrent": "当前已共享给：",
    "quote.shareRevoke": "取消",
    "quote.hideList": "隐藏清单",
    "quote.showList": "显示清单",
    "quote.m.actions": "操作",
    "quote.m.fields": "显示字段",
    "quote.m.editOnDesktop": "改价/改参数请在电脑端操作。",
    "quote.replacePhoto": "替换",
    "quote.hasOrder": "是否有订单",
    "quote.orderProgressHint": "已有订单的产品数 / 产品总数",
    "quote.hasOrderBadge": "有订单",
    "quote.orderNumber": "订单号",
    "quote.resetPhoto": "恢复原图",
    "quote.photoReplaced": "报价图片已更新",
    "quote.noQuotes": "暂无报价单，点击\"新建\"创建。",
    "quote.empty": "报价单为空，点击\"选择产品\"添加。",
    "quote.selectProducts": "选择产品",
    "quote.selectingFor": "正在为报价单选择产品",
    "quote.backToQuote": "返回报价单",
    "quote.switchQuote": "报价单",
    "quote.pickQuote": "选择报价单",
    "quote.switchLatest": "切换报价单（最近 10 条）",
    "quote.allQuotes": "全部报价单",
    "quote.emptyListHint": "还没有报价单，点击下方「新建」创建",
    "quote.size": "尺寸",
    "quote.photo": "图片",
    "quote.description": "产品描述",
    "quote.specification": "产品规格",
    "quote.caseSpec": "外箱规格（长×宽×高）",
    "quote.qty": "40' HQ QTY",
    "quote.items": "个产品",
    "quote.addedTo": "已加入",
    "import.title": "从 Excel 导入产品",
    "import.hint": "上传报价单 (.xlsx)，先解析预览，确认产品无误后再导入系统。",
    "import.previewHint": "请核对以下解析出的产品，点击\"确认导入\"后才会导入系统。",
    "import.format": "表格格式",
    "import.formatWise": "宁波WISE 标准格式",
    "import.formatBetterHome": "Better Home Fashion 报价单格式",
    "import.formatUniversal": "通用（自行映射列）",
    "import.formatUniversalHint": "适用任意工厂报价单 —— 读取表头 → 映射列 → 预览 → 导入",
    "import.next": "下一步",
    "import.sheet": "工作表",
    "import.headerRow": "表头行",
    "import.mapHint": "把 Excel 每一列映射到产品字段。选择「— 忽略 —」的列不会导入。",
    "import.excelColumn": "Excel 列名",
    "import.sampleValues": "样本值",
    "import.mapTo": "映射到",
    "import.ignore": "忽略",
    "import.multiVariant": "相同货号合并为一个产品",
    "import.multiVariantHint": "连续同一货号或货号为空的行会作为该产品的多个规格 / 价格",
    "import.needItemOrDesc": "请至少映射一列到「货号」或「描述」",
    "import.noSheets": "此文件里没有可解析的工作表",
    "import.field.item_number": "货号 (Item No)",
    "import.field.description": "描述",
    "import.field.specification": "规格",
    "import.field.material": "材料",
    "import.field.package": "包装",
    "import.field.moq": "MOQ",
    "import.field.photo": "图片（嵌入 Excel）",
    "import.field.row_size": "尺寸",
    "import.field.row_price": "工厂成本 / 价格",
    "import.field.qty_per_ctn": "每箱数",
    "import.field.container_qty_40": "40HQ 数量",
    "import.field.cbm_ctn": "每箱 CBM",
    "import.field.case_length": "箱长",
    "import.field.case_width": "箱宽",
    "import.field.case_height": "箱高",
    "import.field.case_weight": "箱重 / 毛重",
    "import.field.duty": "关税率",
    "import.preview": "解析预览",
    "import.parsing": "解析中...",
    "import.uploading": "上传中",
    "fm.title": "FileMaker 同步",
    "fm.hint": "从 FileMaker 数据库（产品资料系统2023，layout: product）单向同步到本系统。已有产品更新字段，新产品自动创建；无图片的产品会导入 FileMaker 中的图片。",
    "fm.syncNow": "立即同步",
    "fm.fixCreatedAt": "修正建档日期",
    "fm.fixCreatedAtDone": "已修正 {n} 个产品的建档日期",
    "fm.syncing": "同步中",
    "fm.started": "同步已启动",
    "fm.done": "同步完成",
    "fm.failed": "同步失败",
    "fm.created": "新建",
    "fm.updated": "更新",
    "fm.photos": "图片",
    "fm.thumbs": "缩略图",
    "fm.priceRows": "价格行",
    "import.parsed": "解析产品",
    "import.selectedCount": "已选择",
    "import.confirm": "确认导入",
    "import.exists": "已存在",
    "import.prices": "尺寸 · 价格",
    "import.priceDetails": "尺寸 · 价格 · 装箱量 · CBM · 40'HQ",
    "import.selectAll": "全选",
    "import.deselectAll": "取消全选",
    "import.noPriceColumn": "未识别到价格列——价格可能为 0",
    "import.dropzone": "点击选择 Excel 文件",
    "import.submit": "开始导入",
    "import.importing": "导入中...",
    "import.success": "导入成功",
    "import.error": "导入失败",
    "import.imported": "已导入",
    "import.skipped": "已跳过",
    "import.replaced": "已覆盖",
    "import.renamedFrom": "重命名自",
    "import.overwriteDupes": "覆盖已存在产品（仅限管理员）",
    "import.overwriteHint": "开启后，Excel 中与库内产品编号重复的记录会被完整替换（删除原产品及其所有价格行，再重新导入）。仅管理员可用。",
    "import.overwriteConfirm": "即将覆盖 {n} 条已存在的产品记录。此操作不可撤销，是否继续？",
    "import.rows": "个价格行",
    "import.costCurrency": "此 Excel 中的工厂成本是什么币种？",
    "import.productType": "产品类型（本次导入的所有产品都会标记这个类型）",
    "import.productTypeNone": "不设置",
    "import.productTypeHint": "可选。从「系统设置 → 产品类型」中挑选。",
    "import.category": "产品类别（本次导入的所有产品都会标记这个类别）",
    "rfq.toggleLabel": "询价文件",
    "rfq.toggleHint": "上传客户询价文件，系统会自动识别并填入左侧表单。",
    "rfq.panelTitle": "询价文件识别",
    "rfq.stepUpload": "上传客户询价文件",
    "rfq.stepPreview": "询价文件预览",
    "rfq.dropHere": "点击上传 Excel / PDF / PowerPoint / 图片",
    "rfq.reupload": "重新上传",
    "rfq.reextract": "重新识别",
    "rfq.done": "识别完成",
    "rfq.extracted": "识别完成",
    "rfq.error": "识别失败",
    "rfq.pdfNoPreview": "PDF 已上传（浏览器内无预览，AI 正在识别）",
    "rfq.excelNoPreview": "Excel 已上传（AI 正在识别）",
    "rfq.pptNoPreview": "PowerPoint 已上传（AI 正在识别）",
    "rfq.unknownType": "不支持的格式",
    "import.categoryNone": "不设置",
    "import.categoryHint": "可选。选项来自「系统设置 → 产品类别」。",
    "import.costUsd": "美金 — 导入到「工厂成本（美金）」",
    "import.costRmb": "人民币 — 导入到「工厂成本」",
    "priceList.title": "产品报价列表",
    "priceList.addSize": "添加尺寸",
    "priceList.size": "尺寸",
    "priceList.compressionRate": "压缩率",
    "priceList.qty40Compressed": "压缩后柜量",
    "priceList.importedFrom": "采购报价导入 · 导入人：",
    "priceList.qtyPerCtn": "PCS/CTN",
    "priceList.price": "Price",
    "priceList.factoryCost": "工厂成本",
    "priceList.factoryCostUsd": "工厂成本（美金）",
    "priceList.specification": "规格",
    "priceList.toggleCostCurrency": "切换成本币种（人民币 / 美金）",
    "priceList.caseLength": "箱长",
    "priceList.caseWidth": "箱宽",
    "priceList.caseHeight": "箱高",
    "priceList.caseWeight": "箱重",
    "priceList.quoteTime": "报价日期",
    "priceList.pricePerMeter": "每米价格",
    "priceList.materialUsage": "用料",
    "priceList.processingFee": "加工费",
    "priceList.accessoryPrice": "辅料价格",
    "priceList.profitTax": "利税",
    "priceList.profitTaxHint": "小数，如 0.13 = 13%",
    "priceList.priceComposition": "价格组成",
    "priceList.priceHistory": "价格历史",
    "priceList.formula": "工厂成本 = (每米价格 × 用料 + 加工费 + 辅料价格) × (1 + 利税)",
    "priceList.computedCost": "计算得出的工厂成本",
    "priceList.applyComputed": "应用到工厂成本",
    "priceList.noHistory": "暂无价格历史记录。",
    "priceList.changedBy": "修改人",
    "priceList.saveRowFirst": "请先保存产品后再使用此功能",
    "ai.dropzone": "点击或拖拽上传工厂报价单照片",
    "ai.dropzoneHint": "系统将自动识别中文并翻译成英文填入表单",
    "ai.scanning": "AI 正在识别并翻译...",
    "ai.success": "已从照片中提取信息并自动填表",
    "ai.error": "AI 识别失败",
    "users.title": "用户管理",
    "users.addEmployee": "添加用户",
    "users.name": "姓名",
    "users.email": "邮箱",
    "users.password": "密码",
    "users.passwordNew": "新密码",
    "users.passwordHint": "留空不修改；至少 8 位、含字母和数字",
    "users.passwordLeaveBlank": "留空保持当前密码",
    "users.passwordRule": "密码至少 8 位，必须包含字母和数字",
    "users.role": "角色",
    "users.language": "语言",
    "users.currency": "货币",
    "users.priceMultiplier": "价格系数",
    "users.admin": "管理员",
    "users.employee": "员工",
    "users.editUser": "编辑用户",
    "users.sendReset": "发送密码重置邮件",
    "users.devices": "绑定设备",
    "users.unbindDevices": "解绑全部设备",
    "users.devicesUnbound": "已解绑设备，该用户可在新设备登录",
    "users.role_admin": "管理",
    "users.role_export": "外销",
    "users.role_gt_export": "GT外销",
    "users.role_buyer": "采购",
    "users.role_production_manager": "产品经理",
    "users.role_sales_manager": "销售主管",
    "users.role_procurement_manager": "采购经理",
    "users.role_market_surveyor": "市场调查员",
    "users.role_product_manager": "产品管理员",
    "users.role_user_admin": "用户管理员",
    "users.role_factory": "工厂",
    "users.role_customer": "客户",
    "users.manager": "上级",
    "users.managerNone": "— 无 —",
    "apiTokens.title": "API 令牌",
    "apiTokens.subtitle": "供外部系统调用 API 的长期令牌，永不过期，可随时撤销。",
    "apiTokens.create": "新建令牌",
    "apiTokens.name": "名称",
    "apiTokens.namePlaceholder": "例如 ERP 同步、FileMaker 桥",
    "apiTokens.prefix": "前缀",
    "apiTokens.scope": "权限",
    "apiTokens.scope_fullaccess": "完整访问",
    "apiTokens.scope_fullaccess_hint": "读+写，等同管理员",
    "apiTokens.scope_readonly": "只读",
    "apiTokens.scope_readonly_hint": "仅允许 GET，无法修改数据",
    "apiTokens.createdBy": "创建者",
    "apiTokens.createdAt": "创建时间",
    "apiTokens.lastUsed": "最近使用",
    "apiTokens.status": "状态",
    "apiTokens.active": "有效",
    "apiTokens.revoked": "已撤销",
    "apiTokens.revoke": "撤销",
    "apiTokens.revokeConfirm": "确定要撤销令牌 '{name}' 吗？使用它的外部系统将立即停止工作。",
    "apiTokens.empty": "暂无令牌。创建一个可让外部系统调用 API。",
    "apiTokens.token": "令牌",
    "apiTokens.revealTitle": "请立刻保存此令牌",
    "apiTokens.revealWarning": "完整令牌仅显示这一次。请复制并妥善保存 — 之后将无法再次查看。",
    "apiTokens.usageHint": "请在请求头中使用：",
    "apiTokens.logs": "调用日志",
    "apiTokens.logsSubtitle": "所有通过 API 令牌的请求，按时间倒序。",
    "apiTokens.logs_time": "时间",
    "apiTokens.logs_token": "令牌",
    "apiTokens.logs_method": "方法",
    "apiTokens.logs_path": "路径",
    "apiTokens.logs_status": "状态",
    "apiTokens.logs_duration": "耗时",
    "apiTokens.logs_ip": "IP",
    "apiTokens.logsEmpty": "暂无 API 调用记录。",
  },
};